var cov_24axaiejip = function () {
  var path = '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/indicator/map/mapCtrl.js',
      hash = 'bedf172742a2e779a7172e9c21c1189bf519ceaa',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/views/indicator/map/mapCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 721,
          column: 3
        }
      },
      '1': {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 2,
          column: 37
        }
      },
      '2': {
        start: {
          line: 3,
          column: 2
        },
        end: {
          line: 5,
          column: 3
        }
      },
      '3': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 11
        }
      },
      '4': {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 6,
          column: 34
        }
      },
      '5': {
        start: {
          line: 8,
          column: 15
        },
        end: {
          line: 8,
          column: 28
        }
      },
      '6': {
        start: {
          line: 9,
          column: 17
        },
        end: {
          line: 9,
          column: 34
        }
      },
      '7': {
        start: {
          line: 10,
          column: 20
        },
        end: {
          line: 10,
          column: 36
        }
      },
      '8': {
        start: {
          line: 11,
          column: 21
        },
        end: {
          line: 11,
          column: 43
        }
      },
      '9': {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 30,
          column: 4
        }
      },
      '10': {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 15,
          column: 5
        }
      },
      '11': {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 14,
          column: 13
        }
      },
      '12': {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 28
        }
      },
      '13': {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 29,
          column: 7
        }
      },
      '14': {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 22,
          column: 7
        }
      },
      '15': {
        start: {
          line: 19,
          column: 8
        },
        end: {
          line: 19,
          column: 30
        }
      },
      '16': {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 22
        }
      },
      '17': {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 27,
          column: 7
        }
      },
      '18': {
        start: {
          line: 24,
          column: 8
        },
        end: {
          line: 24,
          column: 30
        }
      },
      '19': {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 26,
          column: 22
        }
      },
      '20': {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 32
        }
      },
      '21': {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 53,
          column: 4
        }
      },
      '22': {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 34,
          column: 5
        }
      },
      '23': {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 33,
          column: 16
        }
      },
      '24': {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 37,
          column: 5
        }
      },
      '25': {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 36,
          column: 34
        }
      },
      '26': {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 40,
          column: 5
        }
      },
      '27': {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 39,
          column: 34
        }
      },
      '28': {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 44,
          column: 5
        }
      },
      '29': {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 43,
          column: 38
        }
      },
      '30': {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 47,
          column: 5
        }
      },
      '31': {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 38
        }
      },
      '32': {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 51,
          column: 5
        }
      },
      '33': {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 50,
          column: 38
        }
      },
      '34': {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 32
        }
      },
      '35': {
        start: {
          line: 54,
          column: 2
        },
        end: {
          line: 54,
          column: 34
        }
      },
      '36': {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 86,
          column: 4
        }
      },
      '37': {
        start: {
          line: 87,
          column: 2
        },
        end: {
          line: 153,
          column: 4
        }
      },
      '38': {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 63
        }
      },
      '39': {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 76
        }
      },
      '40': {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 92,
          column: 5
        }
      },
      '41': {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 91,
          column: 13
        }
      },
      '42': {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 95,
          column: 5
        }
      },
      '43': {
        start: {
          line: 94,
          column: 6
        },
        end: {
          line: 94,
          column: 13
        }
      },
      '44': {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 100,
          column: 5
        }
      },
      '45': {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 97,
          column: 35
        }
      },
      '46': {
        start: {
          line: 98,
          column: 11
        },
        end: {
          line: 100,
          column: 5
        }
      },
      '47': {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 99,
          column: 35
        }
      },
      '48': {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 103,
          column: 5
        }
      },
      '49': {
        start: {
          line: 102,
          column: 6
        },
        end: {
          line: 102,
          column: 13
        }
      },
      '50': {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 107,
          column: 5
        }
      },
      '51': {
        start: {
          line: 106,
          column: 6
        },
        end: {
          line: 106,
          column: 13
        }
      },
      '52': {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 111,
          column: 5
        }
      },
      '53': {
        start: {
          line: 110,
          column: 6
        },
        end: {
          line: 110,
          column: 13
        }
      },
      '54': {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 25
        }
      },
      '55': {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 115,
          column: 35
        }
      },
      '56': {
        start: {
          line: 116,
          column: 4
        },
        end: {
          line: 121,
          column: 5
        }
      },
      '57': {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 120,
          column: 7
        }
      },
      '58': {
        start: {
          line: 118,
          column: 8
        },
        end: {
          line: 118,
          column: 37
        }
      },
      '59': {
        start: {
          line: 119,
          column: 8
        },
        end: {
          line: 119,
          column: 14
        }
      },
      '60': {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 130,
          column: 5
        }
      },
      '61': {
        start: {
          line: 123,
          column: 6
        },
        end: {
          line: 129,
          column: 9
        }
      },
      '62': {
        start: {
          line: 124,
          column: 8
        },
        end: {
          line: 127,
          column: 9
        }
      },
      '63': {
        start: {
          line: 125,
          column: 10
        },
        end: {
          line: 125,
          column: 36
        }
      },
      '64': {
        start: {
          line: 126,
          column: 10
        },
        end: {
          line: 126,
          column: 58
        }
      },
      '65': {
        start: {
          line: 128,
          column: 8
        },
        end: {
          line: 128,
          column: 41
        }
      },
      '66': {
        start: {
          line: 131,
          column: 4
        },
        end: {
          line: 131,
          column: 39
        }
      },
      '67': {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 136,
          column: 5
        }
      },
      '68': {
        start: {
          line: 133,
          column: 6
        },
        end: {
          line: 135,
          column: 7
        }
      },
      '69': {
        start: {
          line: 134,
          column: 8
        },
        end: {
          line: 134,
          column: 47
        }
      },
      '70': {
        start: {
          line: 137,
          column: 4
        },
        end: {
          line: 137,
          column: 111
        }
      },
      '71': {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 138,
          column: 32
        }
      },
      '72': {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 139,
          column: 59
        }
      },
      '73': {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 140,
          column: 62
        }
      },
      '74': {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 142,
          column: 63
        }
      },
      '75': {
        start: {
          line: 144,
          column: 4
        },
        end: {
          line: 144,
          column: 36
        }
      },
      '76': {
        start: {
          line: 145,
          column: 4
        },
        end: {
          line: 145,
          column: 37
        }
      },
      '77': {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 149,
          column: 5
        }
      },
      '78': {
        start: {
          line: 147,
          column: 6
        },
        end: {
          line: 147,
          column: 46
        }
      },
      '79': {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 148,
          column: 45
        }
      },
      '80': {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 150,
          column: 55
        }
      },
      '81': {
        start: {
          line: 151,
          column: 4
        },
        end: {
          line: 151,
          column: 42
        }
      },
      '82': {
        start: {
          line: 152,
          column: 4
        },
        end: {
          line: 152,
          column: 46
        }
      },
      '83': {
        start: {
          line: 154,
          column: 2
        },
        end: {
          line: 163,
          column: 4
        }
      },
      '84': {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 157,
          column: 5
        }
      },
      '85': {
        start: {
          line: 156,
          column: 6
        },
        end: {
          line: 156,
          column: 57
        }
      },
      '86': {
        start: {
          line: 158,
          column: 17
        },
        end: {
          line: 158,
          column: 46
        }
      },
      '87': {
        start: {
          line: 159,
          column: 4
        },
        end: {
          line: 159,
          column: 106
        }
      },
      '88': {
        start: {
          line: 160,
          column: 4
        },
        end: {
          line: 160,
          column: 71
        }
      },
      '89': {
        start: {
          line: 161,
          column: 4
        },
        end: {
          line: 161,
          column: 42
        }
      },
      '90': {
        start: {
          line: 162,
          column: 4
        },
        end: {
          line: 162,
          column: 32
        }
      },
      '91': {
        start: {
          line: 164,
          column: 2
        },
        end: {
          line: 168,
          column: 4
        }
      },
      '92': {
        start: {
          line: 165,
          column: 4
        },
        end: {
          line: 167,
          column: 5
        }
      },
      '93': {
        start: {
          line: 166,
          column: 6
        },
        end: {
          line: 166,
          column: 42
        }
      },
      '94': {
        start: {
          line: 169,
          column: 2
        },
        end: {
          line: 684,
          column: 4
        }
      },
      '95': {
        start: {
          line: 172,
          column: 8
        },
        end: {
          line: 172,
          column: 42
        }
      },
      '96': {
        start: {
          line: 173,
          column: 8
        },
        end: {
          line: 176,
          column: 9
        }
      },
      '97': {
        start: {
          line: 174,
          column: 10
        },
        end: {
          line: 174,
          column: 40
        }
      },
      '98': {
        start: {
          line: 175,
          column: 10
        },
        end: {
          line: 175,
          column: 33
        }
      },
      '99': {
        start: {
          line: 178,
          column: 8
        },
        end: {
          line: 178,
          column: 43
        }
      },
      '100': {
        start: {
          line: 179,
          column: 8
        },
        end: {
          line: 179,
          column: 55
        }
      },
      '101': {
        start: {
          line: 180,
          column: 8
        },
        end: {
          line: 200,
          column: 11
        }
      },
      '102': {
        start: {
          line: 186,
          column: 10
        },
        end: {
          line: 197,
          column: 11
        }
      },
      '103': {
        start: {
          line: 187,
          column: 12
        },
        end: {
          line: 187,
          column: 32
        }
      },
      '104': {
        start: {
          line: 188,
          column: 12
        },
        end: {
          line: 188,
          column: 32
        }
      },
      '105': {
        start: {
          line: 189,
          column: 12
        },
        end: {
          line: 189,
          column: 32
        }
      },
      '106': {
        start: {
          line: 190,
          column: 12
        },
        end: {
          line: 190,
          column: 32
        }
      },
      '107': {
        start: {
          line: 191,
          column: 12
        },
        end: {
          line: 196,
          column: 13
        }
      },
      '108': {
        start: {
          line: 192,
          column: 14
        },
        end: {
          line: 192,
          column: 36
        }
      },
      '109': {
        start: {
          line: 193,
          column: 14
        },
        end: {
          line: 193,
          column: 36
        }
      },
      '110': {
        start: {
          line: 194,
          column: 14
        },
        end: {
          line: 194,
          column: 36
        }
      },
      '111': {
        start: {
          line: 195,
          column: 14
        },
        end: {
          line: 195,
          column: 36
        }
      },
      '112': {
        start: {
          line: 198,
          column: 10
        },
        end: {
          line: 198,
          column: 44
        }
      },
      '113': {
        start: {
          line: 199,
          column: 10
        },
        end: {
          line: 199,
          column: 51
        }
      },
      '114': {
        start: {
          line: 203,
          column: 8
        },
        end: {
          line: 205,
          column: 9
        }
      },
      '115': {
        start: {
          line: 204,
          column: 10
        },
        end: {
          line: 204,
          column: 17
        }
      },
      '116': {
        start: {
          line: 206,
          column: 21
        },
        end: {
          line: 206,
          column: 50
        }
      },
      '117': {
        start: {
          line: 207,
          column: 8
        },
        end: {
          line: 216,
          column: 9
        }
      },
      '118': {
        start: {
          line: 208,
          column: 10
        },
        end: {
          line: 208,
          column: 77
        }
      },
      '119': {
        start: {
          line: 210,
          column: 10
        },
        end: {
          line: 215,
          column: 11
        }
      },
      '120': {
        start: {
          line: 211,
          column: 12
        },
        end: {
          line: 214,
          column: 13
        }
      },
      '121': {
        start: {
          line: 212,
          column: 14
        },
        end: {
          line: 212,
          column: 49
        }
      },
      '122': {
        start: {
          line: 213,
          column: 14
        },
        end: {
          line: 213,
          column: 20
        }
      },
      '123': {
        start: {
          line: 218,
          column: 8
        },
        end: {
          line: 243,
          column: 11
        }
      },
      '124': {
        start: {
          line: 225,
          column: 10
        },
        end: {
          line: 232,
          column: 11
        }
      },
      '125': {
        start: {
          line: 226,
          column: 12
        },
        end: {
          line: 231,
          column: 13
        }
      },
      '126': {
        start: {
          line: 227,
          column: 14
        },
        end: {
          line: 227,
          column: 36
        }
      },
      '127': {
        start: {
          line: 228,
          column: 14
        },
        end: {
          line: 228,
          column: 36
        }
      },
      '128': {
        start: {
          line: 229,
          column: 14
        },
        end: {
          line: 229,
          column: 36
        }
      },
      '129': {
        start: {
          line: 230,
          column: 14
        },
        end: {
          line: 230,
          column: 36
        }
      },
      '130': {
        start: {
          line: 233,
          column: 10
        },
        end: {
          line: 241,
          column: 11
        }
      },
      '131': {
        start: {
          line: 234,
          column: 12
        },
        end: {
          line: 234,
          column: 24
        }
      },
      '132': {
        start: {
          line: 235,
          column: 12
        },
        end: {
          line: 240,
          column: 13
        }
      },
      '133': {
        start: {
          line: 236,
          column: 14
        },
        end: {
          line: 239,
          column: 15
        }
      },
      '134': {
        start: {
          line: 237,
          column: 16
        },
        end: {
          line: 237,
          column: 31
        }
      },
      '135': {
        start: {
          line: 238,
          column: 16
        },
        end: {
          line: 238,
          column: 22
        }
      },
      '136': {
        start: {
          line: 242,
          column: 10
        },
        end: {
          line: 242,
          column: 59
        }
      },
      '137': {
        start: {
          line: 246,
          column: 23
        },
        end: {
          line: 246,
          column: 24
        }
      },
      '138': {
        start: {
          line: 247,
          column: 23
        },
        end: {
          line: 247,
          column: 32
        }
      },
      '139': {
        start: {
          line: 248,
          column: 21
        },
        end: {
          line: 248,
          column: 23
        }
      },
      '140': {
        start: {
          line: 249,
          column: 8
        },
        end: {
          line: 260,
          column: 9
        }
      },
      '141': {
        start: {
          line: 250,
          column: 10
        },
        end: {
          line: 252,
          column: 11
        }
      },
      '142': {
        start: {
          line: 251,
          column: 12
        },
        end: {
          line: 251,
          column: 21
        }
      },
      '143': {
        start: {
          line: 253,
          column: 10
        },
        end: {
          line: 255,
          column: 11
        }
      },
      '144': {
        start: {
          line: 254,
          column: 12
        },
        end: {
          line: 254,
          column: 29
        }
      },
      '145': {
        start: {
          line: 256,
          column: 10
        },
        end: {
          line: 258,
          column: 11
        }
      },
      '146': {
        start: {
          line: 257,
          column: 12
        },
        end: {
          line: 257,
          column: 29
        }
      },
      '147': {
        start: {
          line: 259,
          column: 10
        },
        end: {
          line: 259,
          column: 55
        }
      },
      '148': {
        start: {
          line: 261,
          column: 8
        },
        end: {
          line: 261,
          column: 52
        }
      },
      '149': {
        start: {
          line: 264,
          column: 23
        },
        end: {
          line: 264,
          column: 24
        }
      },
      '150': {
        start: {
          line: 265,
          column: 23
        },
        end: {
          line: 265,
          column: 32
        }
      },
      '151': {
        start: {
          line: 266,
          column: 21
        },
        end: {
          line: 266,
          column: 23
        }
      },
      '152': {
        start: {
          line: 267,
          column: 8
        },
        end: {
          line: 283,
          column: 9
        }
      },
      '153': {
        start: {
          line: 268,
          column: 10
        },
        end: {
          line: 282,
          column: 11
        }
      },
      '154': {
        start: {
          line: 269,
          column: 12
        },
        end: {
          line: 271,
          column: 13
        }
      },
      '155': {
        start: {
          line: 270,
          column: 14
        },
        end: {
          line: 270,
          column: 23
        }
      },
      '156': {
        start: {
          line: 272,
          column: 12
        },
        end: {
          line: 274,
          column: 13
        }
      },
      '157': {
        start: {
          line: 273,
          column: 14
        },
        end: {
          line: 273,
          column: 23
        }
      },
      '158': {
        start: {
          line: 275,
          column: 12
        },
        end: {
          line: 277,
          column: 13
        }
      },
      '159': {
        start: {
          line: 276,
          column: 14
        },
        end: {
          line: 276,
          column: 31
        }
      },
      '160': {
        start: {
          line: 278,
          column: 12
        },
        end: {
          line: 280,
          column: 13
        }
      },
      '161': {
        start: {
          line: 279,
          column: 14
        },
        end: {
          line: 279,
          column: 31
        }
      },
      '162': {
        start: {
          line: 281,
          column: 12
        },
        end: {
          line: 281,
          column: 58
        }
      },
      '163': {
        start: {
          line: 284,
          column: 8
        },
        end: {
          line: 284,
          column: 52
        }
      },
      '164': {
        start: {
          line: 287,
          column: 23
        },
        end: {
          line: 287,
          column: 24
        }
      },
      '165': {
        start: {
          line: 288,
          column: 23
        },
        end: {
          line: 288,
          column: 32
        }
      },
      '166': {
        start: {
          line: 289,
          column: 21
        },
        end: {
          line: 289,
          column: 23
        }
      },
      '167': {
        start: {
          line: 290,
          column: 8
        },
        end: {
          line: 306,
          column: 9
        }
      },
      '168': {
        start: {
          line: 291,
          column: 10
        },
        end: {
          line: 305,
          column: 11
        }
      },
      '169': {
        start: {
          line: 292,
          column: 12
        },
        end: {
          line: 294,
          column: 13
        }
      },
      '170': {
        start: {
          line: 293,
          column: 14
        },
        end: {
          line: 293,
          column: 23
        }
      },
      '171': {
        start: {
          line: 295,
          column: 12
        },
        end: {
          line: 297,
          column: 13
        }
      },
      '172': {
        start: {
          line: 296,
          column: 14
        },
        end: {
          line: 296,
          column: 23
        }
      },
      '173': {
        start: {
          line: 298,
          column: 12
        },
        end: {
          line: 300,
          column: 13
        }
      },
      '174': {
        start: {
          line: 299,
          column: 14
        },
        end: {
          line: 299,
          column: 31
        }
      },
      '175': {
        start: {
          line: 301,
          column: 12
        },
        end: {
          line: 303,
          column: 13
        }
      },
      '176': {
        start: {
          line: 302,
          column: 14
        },
        end: {
          line: 302,
          column: 31
        }
      },
      '177': {
        start: {
          line: 304,
          column: 12
        },
        end: {
          line: 304,
          column: 58
        }
      },
      '178': {
        start: {
          line: 307,
          column: 8
        },
        end: {
          line: 307,
          column: 52
        }
      },
      '179': {
        start: {
          line: 310,
          column: 19
        },
        end: {
          line: 310,
          column: 21
        }
      },
      '180': {
        start: {
          line: 311,
          column: 8
        },
        end: {
          line: 322,
          column: 9
        }
      },
      '181': {
        start: {
          line: 313,
          column: 12
        },
        end: {
          line: 313,
          column: 42
        }
      },
      '182': {
        start: {
          line: 314,
          column: 12
        },
        end: {
          line: 314,
          column: 18
        }
      },
      '183': {
        start: {
          line: 316,
          column: 12
        },
        end: {
          line: 316,
          column: 42
        }
      },
      '184': {
        start: {
          line: 317,
          column: 12
        },
        end: {
          line: 317,
          column: 18
        }
      },
      '185': {
        start: {
          line: 319,
          column: 12
        },
        end: {
          line: 319,
          column: 42
        }
      },
      '186': {
        start: {
          line: 320,
          column: 12
        },
        end: {
          line: 320,
          column: 18
        }
      },
      '187': {
        start: {
          line: 323,
          column: 8
        },
        end: {
          line: 323,
          column: 38
        }
      },
      '188': {
        start: {
          line: 324,
          column: 8
        },
        end: {
          line: 360,
          column: 9
        }
      },
      '189': {
        start: {
          line: 325,
          column: 24
        },
        end: {
          line: 325,
          column: 33
        }
      },
      '190': {
        start: {
          line: 326,
          column: 18
        },
        end: {
          line: 326,
          column: 19
        }
      },
      '191': {
        start: {
          line: 327,
          column: 18
        },
        end: {
          line: 327,
          column: 19
        }
      },
      '192': {
        start: {
          line: 328,
          column: 20
        },
        end: {
          line: 328,
          column: 22
        }
      },
      '193': {
        start: {
          line: 329,
          column: 10
        },
        end: {
          line: 336,
          column: 11
        }
      },
      '194': {
        start: {
          line: 330,
          column: 12
        },
        end: {
          line: 335,
          column: 13
        }
      },
      '195': {
        start: {
          line: 331,
          column: 14
        },
        end: {
          line: 331,
          column: 30
        }
      },
      '196': {
        start: {
          line: 332,
          column: 14
        },
        end: {
          line: 332,
          column: 29
        }
      },
      '197': {
        start: {
          line: 333,
          column: 14
        },
        end: {
          line: 333,
          column: 50
        }
      },
      '198': {
        start: {
          line: 334,
          column: 14
        },
        end: {
          line: 334,
          column: 20
        }
      },
      '199': {
        start: {
          line: 337,
          column: 10
        },
        end: {
          line: 339,
          column: 11
        }
      },
      '200': {
        start: {
          line: 338,
          column: 12
        },
        end: {
          line: 338,
          column: 21
        }
      },
      '201': {
        start: {
          line: 340,
          column: 38
        },
        end: {
          line: 347,
          column: 11
        }
      },
      '202': {
        start: {
          line: 349,
          column: 25
        },
        end: {
          line: 349,
          column: 74
        }
      },
      '203': {
        start: {
          line: 350,
          column: 25
        },
        end: {
          line: 355,
          column: 32
        }
      },
      '204': {
        start: {
          line: 356,
          column: 10
        },
        end: {
          line: 356,
          column: 35
        }
      },
      '205': {
        start: {
          line: 357,
          column: 10
        },
        end: {
          line: 357,
          column: 37
        }
      },
      '206': {
        start: {
          line: 359,
          column: 10
        },
        end: {
          line: 359,
          column: 40
        }
      },
      '207': {
        start: {
          line: 365,
          column: 34
        },
        end: {
          line: 372,
          column: 9
        }
      },
      '208': {
        start: {
          line: 373,
          column: 20
        },
        end: {
          line: 373,
          column: 47
        }
      },
      '209': {
        start: {
          line: 374,
          column: 8
        },
        end: {
          line: 374,
          column: 43
        }
      },
      '210': {
        start: {
          line: 375,
          column: 8
        },
        end: {
          line: 378,
          column: 9
        }
      },
      '211': {
        start: {
          line: 376,
          column: 22
        },
        end: {
          line: 376,
          column: 38
        }
      },
      '212': {
        start: {
          line: 377,
          column: 10
        },
        end: {
          line: 377,
          column: 75
        }
      },
      '213': {
        start: {
          line: 382,
          column: 8
        },
        end: {
          line: 390,
          column: 11
        }
      },
      '214': {
        start: {
          line: 387,
          column: 23
        },
        end: {
          line: 387,
          column: 36
        }
      },
      '215': {
        start: {
          line: 393,
          column: 8
        },
        end: {
          line: 445,
          column: 11
        }
      },
      '216': {
        start: {
          line: 399,
          column: 10
        },
        end: {
          line: 444,
          column: 11
        }
      },
      '217': {
        start: {
          line: 400,
          column: 12
        },
        end: {
          line: 402,
          column: 13
        }
      },
      '218': {
        start: {
          line: 401,
          column: 14
        },
        end: {
          line: 401,
          column: 23
        }
      },
      '219': {
        start: {
          line: 403,
          column: 22
        },
        end: {
          line: 403,
          column: 24
        }
      },
      '220': {
        start: {
          line: 404,
          column: 12
        },
        end: {
          line: 409,
          column: 13
        }
      },
      '221': {
        start: {
          line: 405,
          column: 14
        },
        end: {
          line: 408,
          column: 15
        }
      },
      '222': {
        start: {
          line: 406,
          column: 16
        },
        end: {
          line: 406,
          column: 32
        }
      },
      '223': {
        start: {
          line: 407,
          column: 16
        },
        end: {
          line: 407,
          column: 22
        }
      },
      '224': {
        start: {
          line: 410,
          column: 12
        },
        end: {
          line: 410,
          column: 36
        }
      },
      '225': {
        start: {
          line: 411,
          column: 26
        },
        end: {
          line: 411,
          column: 81
        }
      },
      '226': {
        start: {
          line: 412,
          column: 12
        },
        end: {
          line: 441,
          column: 13
        }
      },
      '227': {
        start: {
          line: 413,
          column: 14
        },
        end: {
          line: 413,
          column: 33
        }
      },
      '228': {
        start: {
          line: 414,
          column: 14
        },
        end: {
          line: 416,
          column: 15
        }
      },
      '229': {
        start: {
          line: 415,
          column: 16
        },
        end: {
          line: 415,
          column: 23
        }
      },
      '230': {
        start: {
          line: 417,
          column: 29
        },
        end: {
          line: 417,
          column: 46
        }
      },
      '231': {
        start: {
          line: 418,
          column: 14
        },
        end: {
          line: 420,
          column: 15
        }
      },
      '232': {
        start: {
          line: 419,
          column: 16
        },
        end: {
          line: 419,
          column: 70
        }
      },
      '233': {
        start: {
          line: 421,
          column: 14
        },
        end: {
          line: 421,
          column: 42
        }
      },
      '234': {
        start: {
          line: 422,
          column: 14
        },
        end: {
          line: 439,
          column: 17
        }
      },
      '235': {
        start: {
          line: 427,
          column: 16
        },
        end: {
          line: 438,
          column: 19
        }
      },
      '236': {
        start: {
          line: 429,
          column: 20
        },
        end: {
          line: 436,
          column: 23
        }
      },
      '237': {
        start: {
          line: 430,
          column: 22
        },
        end: {
          line: 430,
          column: 51
        }
      },
      '238': {
        start: {
          line: 431,
          column: 22
        },
        end: {
          line: 431,
          column: 41
        }
      },
      '239': {
        start: {
          line: 432,
          column: 22
        },
        end: {
          line: 432,
          column: 43
        }
      },
      '240': {
        start: {
          line: 433,
          column: 22
        },
        end: {
          line: 435,
          column: 23
        }
      },
      '241': {
        start: {
          line: 434,
          column: 24
        },
        end: {
          line: 434,
          column: 100
        }
      },
      '242': {
        start: {
          line: 440,
          column: 14
        },
        end: {
          line: 440,
          column: 21
        }
      },
      '243': {
        start: {
          line: 442,
          column: 12
        },
        end: {
          line: 442,
          column: 40
        }
      },
      '244': {
        start: {
          line: 443,
          column: 12
        },
        end: {
          line: 443,
          column: 44
        }
      },
      '245': {
        start: {
          line: 448,
          column: 8
        },
        end: {
          line: 468,
          column: 11
        }
      },
      '246': {
        start: {
          line: 449,
          column: 27
        },
        end: {
          line: 449,
          column: 54
        }
      },
      '247': {
        start: {
          line: 450,
          column: 22
        },
        end: {
          line: 450,
          column: 37
        }
      },
      '248': {
        start: {
          line: 451,
          column: 10
        },
        end: {
          line: 463,
          column: 11
        }
      },
      '249': {
        start: {
          line: 452,
          column: 12
        },
        end: {
          line: 462,
          column: 13
        }
      },
      '250': {
        start: {
          line: 453,
          column: 30
        },
        end: {
          line: 453,
          column: 34
        }
      },
      '251': {
        start: {
          line: 454,
          column: 26
        },
        end: {
          line: 454,
          column: 40
        }
      },
      '252': {
        start: {
          line: 455,
          column: 14
        },
        end: {
          line: 457,
          column: 15
        }
      },
      '253': {
        start: {
          line: 456,
          column: 16
        },
        end: {
          line: 456,
          column: 49
        }
      },
      '254': {
        start: {
          line: 458,
          column: 14
        },
        end: {
          line: 458,
          column: 59
        }
      },
      '255': {
        start: {
          line: 459,
          column: 14
        },
        end: {
          line: 461,
          column: 15
        }
      },
      '256': {
        start: {
          line: 460,
          column: 16
        },
        end: {
          line: 460,
          column: 22
        }
      },
      '257': {
        start: {
          line: 464,
          column: 10
        },
        end: {
          line: 467,
          column: 52
        }
      },
      '258': {
        start: {
          line: 471,
          column: 21
        },
        end: {
          line: 471,
          column: 50
        }
      },
      '259': {
        start: {
          line: 472,
          column: 8
        },
        end: {
          line: 472,
          column: 110
        }
      },
      '260': {
        start: {
          line: 473,
          column: 8
        },
        end: {
          line: 473,
          column: 75
        }
      },
      '261': {
        start: {
          line: 474,
          column: 8
        },
        end: {
          line: 474,
          column: 28
        }
      },
      '262': {
        start: {
          line: 478,
          column: 8
        },
        end: {
          line: 494,
          column: 11
        }
      },
      '263': {
        start: {
          line: 484,
          column: 10
        },
        end: {
          line: 484,
          column: 57
        }
      },
      '264': {
        start: {
          line: 491,
          column: 10
        },
        end: {
          line: 493,
          column: 11
        }
      },
      '265': {
        start: {
          line: 492,
          column: 12
        },
        end: {
          line: 492,
          column: 17
        }
      },
      '266': {
        start: {
          line: 495,
          column: 8
        },
        end: {
          line: 495,
          column: 20
        }
      },
      '267': {
        start: {
          line: 498,
          column: 8
        },
        end: {
          line: 498,
          column: 27
        }
      },
      '268': {
        start: {
          line: 499,
          column: 8
        },
        end: {
          line: 509,
          column: 9
        }
      },
      '269': {
        start: {
          line: 500,
          column: 10
        },
        end: {
          line: 502,
          column: 11
        }
      },
      '270': {
        start: {
          line: 501,
          column: 12
        },
        end: {
          line: 501,
          column: 21
        }
      },
      '271': {
        start: {
          line: 503,
          column: 10
        },
        end: {
          line: 508,
          column: 13
        }
      },
      '272': {
        start: {
          line: 510,
          column: 8
        },
        end: {
          line: 517,
          column: 11
        }
      },
      '273': {
        start: {
          line: 521,
          column: 19
        },
        end: {
          line: 521,
          column: 21
        }
      },
      '274': {
        start: {
          line: 522,
          column: 20
        },
        end: {
          line: 522,
          column: 79
        }
      },
      '275': {
        start: {
          line: 523,
          column: 6
        },
        end: {
          line: 539,
          column: 7
        }
      },
      '276': {
        start: {
          line: 525,
          column: 10
        },
        end: {
          line: 525,
          column: 107
        }
      },
      '277': {
        start: {
          line: 526,
          column: 10
        },
        end: {
          line: 526,
          column: 16
        }
      },
      '278': {
        start: {
          line: 528,
          column: 10
        },
        end: {
          line: 528,
          column: 107
        }
      },
      '279': {
        start: {
          line: 529,
          column: 10
        },
        end: {
          line: 529,
          column: 16
        }
      },
      '280': {
        start: {
          line: 531,
          column: 10
        },
        end: {
          line: 531,
          column: 107
        }
      },
      '281': {
        start: {
          line: 532,
          column: 10
        },
        end: {
          line: 532,
          column: 16
        }
      },
      '282': {
        start: {
          line: 534,
          column: 10
        },
        end: {
          line: 534,
          column: 107
        }
      },
      '283': {
        start: {
          line: 535,
          column: 10
        },
        end: {
          line: 535,
          column: 16
        }
      },
      '284': {
        start: {
          line: 537,
          column: 10
        },
        end: {
          line: 537,
          column: 107
        }
      },
      '285': {
        start: {
          line: 538,
          column: 10
        },
        end: {
          line: 538,
          column: 16
        }
      },
      '286': {
        start: {
          line: 540,
          column: 6
        },
        end: {
          line: 540,
          column: 124
        }
      },
      '287': {
        start: {
          line: 543,
          column: 6
        },
        end: {
          line: 543,
          column: 60
        }
      },
      '288': {
        start: {
          line: 546,
          column: 6
        },
        end: {
          line: 548,
          column: 7
        }
      },
      '289': {
        start: {
          line: 547,
          column: 8
        },
        end: {
          line: 547,
          column: 36
        }
      },
      '290': {
        start: {
          line: 551,
          column: 6
        },
        end: {
          line: 553,
          column: 7
        }
      },
      '291': {
        start: {
          line: 552,
          column: 8
        },
        end: {
          line: 552,
          column: 38
        }
      },
      '292': {
        start: {
          line: 556,
          column: 6
        },
        end: {
          line: 558,
          column: 7
        }
      },
      '293': {
        start: {
          line: 557,
          column: 8
        },
        end: {
          line: 557,
          column: 44
        }
      },
      '294': {
        start: {
          line: 562,
          column: 21
        },
        end: {
          line: 578,
          column: 7
        }
      },
      '295': {
        start: {
          line: 579,
          column: 18
        },
        end: {
          line: 579,
          column: 45
        }
      },
      '296': {
        start: {
          line: 580,
          column: 6
        },
        end: {
          line: 580,
          column: 41
        }
      },
      '297': {
        start: {
          line: 581,
          column: 6
        },
        end: {
          line: 588,
          column: 7
        }
      },
      '298': {
        start: {
          line: 582,
          column: 20
        },
        end: {
          line: 582,
          column: 36
        }
      },
      '299': {
        start: {
          line: 583,
          column: 8
        },
        end: {
          line: 587,
          column: 9
        }
      },
      '300': {
        start: {
          line: 584,
          column: 10
        },
        end: {
          line: 584,
          column: 48
        }
      },
      '301': {
        start: {
          line: 585,
          column: 10
        },
        end: {
          line: 585,
          column: 50
        }
      },
      '302': {
        start: {
          line: 586,
          column: 10
        },
        end: {
          line: 586,
          column: 16
        }
      },
      '303': {
        start: {
          line: 589,
          column: 6
        },
        end: {
          line: 589,
          column: 30
        }
      },
      '304': {
        start: {
          line: 592,
          column: 6
        },
        end: {
          line: 597,
          column: 7
        }
      },
      '305': {
        start: {
          line: 593,
          column: 8
        },
        end: {
          line: 595,
          column: 11
        }
      },
      '306': {
        start: {
          line: 596,
          column: 8
        },
        end: {
          line: 596,
          column: 42
        }
      },
      '307': {
        start: {
          line: 598,
          column: 6
        },
        end: {
          line: 598,
          column: 36
        }
      },
      '308': {
        start: {
          line: 599,
          column: 6
        },
        end: {
          line: 645,
          column: 9
        }
      },
      '309': {
        start: {
          line: 600,
          column: 8
        },
        end: {
          line: 600,
          column: 118
        }
      },
      '310': {
        start: {
          line: 601,
          column: 8
        },
        end: {
          line: 641,
          column: 9
        }
      },
      '311': {
        start: {
          line: 602,
          column: 22
        },
        end: {
          line: 602,
          column: 65
        }
      },
      '312': {
        start: {
          line: 603,
          column: 10
        },
        end: {
          line: 640,
          column: 11
        }
      },
      '313': {
        start: {
          line: 604,
          column: 26
        },
        end: {
          line: 610,
          column: 50
        }
      },
      '314': {
        start: {
          line: 611,
          column: 12
        },
        end: {
          line: 611,
          column: 36
        }
      },
      '315': {
        start: {
          line: 613,
          column: 26
        },
        end: {
          line: 629,
          column: 50
        }
      },
      '316': {
        start: {
          line: 622,
          column: 16
        },
        end: {
          line: 627,
          column: 18
        }
      },
      '317': {
        start: {
          line: 630,
          column: 12
        },
        end: {
          line: 639,
          column: 14
        }
      },
      '318': {
        start: {
          line: 631,
          column: 14
        },
        end: {
          line: 638,
          column: 15
        }
      },
      '319': {
        start: {
          line: 632,
          column: 16
        },
        end: {
          line: 632,
          column: 52
        }
      },
      '320': {
        start: {
          line: 633,
          column: 16
        },
        end: {
          line: 635,
          column: 17
        }
      },
      '321': {
        start: {
          line: 634,
          column: 18
        },
        end: {
          line: 634,
          column: 99
        }
      },
      '322': {
        start: {
          line: 637,
          column: 16
        },
        end: {
          line: 637,
          column: 35
        }
      },
      '323': {
        start: {
          line: 642,
          column: 8
        },
        end: {
          line: 644,
          column: 9
        }
      },
      '324': {
        start: {
          line: 643,
          column: 10
        },
        end: {
          line: 643,
          column: 55
        }
      },
      '325': {
        start: {
          line: 649,
          column: 6
        },
        end: {
          line: 649,
          column: 27
        }
      },
      '326': {
        start: {
          line: 650,
          column: 6
        },
        end: {
          line: 652,
          column: 7
        }
      },
      '327': {
        start: {
          line: 651,
          column: 8
        },
        end: {
          line: 651,
          column: 28
        }
      },
      '328': {
        start: {
          line: 653,
          column: 6
        },
        end: {
          line: 653,
          column: 60
        }
      },
      '329': {
        start: {
          line: 655,
          column: 6
        },
        end: {
          line: 658,
          column: 7
        }
      },
      '330': {
        start: {
          line: 656,
          column: 8
        },
        end: {
          line: 656,
          column: 38
        }
      },
      '331': {
        start: {
          line: 657,
          column: 8
        },
        end: {
          line: 657,
          column: 31
        }
      },
      '332': {
        start: {
          line: 660,
          column: 6
        },
        end: {
          line: 660,
          column: 23
        }
      },
      '333': {
        start: {
          line: 661,
          column: 6
        },
        end: {
          line: 661,
          column: 156
        }
      },
      '334': {
        start: {
          line: 665,
          column: 6
        },
        end: {
          line: 665,
          column: 35
        }
      },
      '335': {
        start: {
          line: 666,
          column: 6
        },
        end: {
          line: 666,
          column: 37
        }
      },
      '336': {
        start: {
          line: 667,
          column: 6
        },
        end: {
          line: 672,
          column: 7
        }
      },
      '337': {
        start: {
          line: 668,
          column: 8
        },
        end: {
          line: 671,
          column: 9
        }
      },
      '338': {
        start: {
          line: 669,
          column: 10
        },
        end: {
          line: 669,
          column: 39
        }
      },
      '339': {
        start: {
          line: 670,
          column: 10
        },
        end: {
          line: 670,
          column: 16
        }
      },
      '340': {
        start: {
          line: 673,
          column: 6
        },
        end: {
          line: 673,
          column: 113
        }
      },
      '341': {
        start: {
          line: 674,
          column: 6
        },
        end: {
          line: 674,
          column: 28
        }
      },
      '342': {
        start: {
          line: 675,
          column: 6
        },
        end: {
          line: 675,
          column: 34
        }
      },
      '343': {
        start: {
          line: 676,
          column: 6
        },
        end: {
          line: 676,
          column: 64
        }
      },
      '344': {
        start: {
          line: 677,
          column: 6
        },
        end: {
          line: 677,
          column: 38
        }
      },
      '345': {
        start: {
          line: 678,
          column: 6
        },
        end: {
          line: 680,
          column: 7
        }
      },
      '346': {
        start: {
          line: 679,
          column: 8
        },
        end: {
          line: 679,
          column: 48
        }
      },
      '347': {
        start: {
          line: 681,
          column: 6
        },
        end: {
          line: 681,
          column: 44
        }
      },
      '348': {
        start: {
          line: 682,
          column: 6
        },
        end: {
          line: 682,
          column: 48
        }
      },
      '349': {
        start: {
          line: 685,
          column: 22
        },
        end: {
          line: 696,
          column: 65
        }
      },
      '350': {
        start: {
          line: 697,
          column: 2
        },
        end: {
          line: 699,
          column: 5
        }
      },
      '351': {
        start: {
          line: 698,
          column: 4
        },
        end: {
          line: 698,
          column: 27
        }
      },
      '352': {
        start: {
          line: 700,
          column: 2
        },
        end: {
          line: 702,
          column: 5
        }
      },
      '353': {
        start: {
          line: 701,
          column: 4
        },
        end: {
          line: 701,
          column: 27
        }
      },
      '354': {
        start: {
          line: 703,
          column: 2
        },
        end: {
          line: 720,
          column: 5
        }
      },
      '355': {
        start: {
          line: 704,
          column: 4
        },
        end: {
          line: 719,
          column: 7
        }
      },
      '356': {
        start: {
          line: 705,
          column: 6
        },
        end: {
          line: 717,
          column: 7
        }
      },
      '357': {
        start: {
          line: 706,
          column: 8
        },
        end: {
          line: 706,
          column: 70
        }
      },
      '358': {
        start: {
          line: 707,
          column: 8
        },
        end: {
          line: 707,
          column: 70
        }
      },
      '359': {
        start: {
          line: 708,
          column: 8
        },
        end: {
          line: 708,
          column: 55
        }
      },
      '360': {
        start: {
          line: 709,
          column: 8
        },
        end: {
          line: 709,
          column: 57
        }
      },
      '361': {
        start: {
          line: 710,
          column: 8
        },
        end: {
          line: 710,
          column: 53
        }
      },
      '362': {
        start: {
          line: 711,
          column: 8
        },
        end: {
          line: 711,
          column: 49
        }
      },
      '363': {
        start: {
          line: 712,
          column: 8
        },
        end: {
          line: 712,
          column: 85
        }
      },
      '364': {
        start: {
          line: 713,
          column: 8
        },
        end: {
          line: 713,
          column: 51
        }
      },
      '365': {
        start: {
          line: 714,
          column: 8
        },
        end: {
          line: 716,
          column: 9
        }
      },
      '366': {
        start: {
          line: 715,
          column: 10
        },
        end: {
          line: 715,
          column: 35
        }
      },
      '367': {
        start: {
          line: 718,
          column: 6
        },
        end: {
          line: 718,
          column: 36
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 1,
            column: 53
          },
          end: {
            line: 1,
            column: 54
          }
        },
        loc: {
          start: {
            line: 1,
            column: 285
          },
          end: {
            line: 721,
            column: 1
          }
        },
        line: 1
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 12,
            column: 26
          },
          end: {
            line: 12,
            column: 27
          }
        },
        loc: {
          start: {
            line: 12,
            column: 47
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 12
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 17,
            column: 100
          },
          end: {
            line: 17,
            column: 101
          }
        },
        loc: {
          start: {
            line: 17,
            column: 108
          },
          end: {
            line: 29,
            column: 5
          }
        },
        line: 17
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 31,
            column: 30
          },
          end: {
            line: 31,
            column: 31
          }
        },
        loc: {
          start: {
            line: 31,
            column: 46
          },
          end: {
            line: 53,
            column: 3
          }
        },
        line: 31
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 87,
            column: 25
          },
          end: {
            line: 87,
            column: 26
          }
        },
        loc: {
          start: {
            line: 87,
            column: 41
          },
          end: {
            line: 153,
            column: 3
          }
        },
        line: 87
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 123,
            column: 64
          },
          end: {
            line: 123,
            column: 65
          }
        },
        loc: {
          start: {
            line: 123,
            column: 72
          },
          end: {
            line: 129,
            column: 7
          }
        },
        line: 123
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 154,
            column: 27
          },
          end: {
            line: 154,
            column: 28
          }
        },
        loc: {
          start: {
            line: 154,
            column: 39
          },
          end: {
            line: 163,
            column: 3
          }
        },
        line: 154
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 164,
            column: 29
          },
          end: {
            line: 164,
            column: 30
          }
        },
        loc: {
          start: {
            line: 164,
            column: 41
          },
          end: {
            line: 168,
            column: 3
          }
        },
        line: 164
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 185,
            column: 11
          },
          end: {
            line: 185,
            column: 12
          }
        },
        loc: {
          start: {
            line: 185,
            column: 19
          },
          end: {
            line: 200,
            column: 9
          }
        },
        line: 185
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 224,
            column: 11
          },
          end: {
            line: 224,
            column: 12
          }
        },
        loc: {
          start: {
            line: 224,
            column: 19
          },
          end: {
            line: 243,
            column: 9
          }
        },
        line: 224
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 386,
            column: 16
          },
          end: {
            line: 386,
            column: 17
          }
        },
        loc: {
          start: {
            line: 386,
            column: 28
          },
          end: {
            line: 388,
            column: 9
          }
        },
        line: 386
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 388,
            column: 11
          },
          end: {
            line: 388,
            column: 12
          }
        },
        loc: {
          start: {
            line: 388,
            column: 17
          },
          end: {
            line: 390,
            column: 9
          }
        },
        line: 388
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 398,
            column: 11
          },
          end: {
            line: 398,
            column: 12
          }
        },
        loc: {
          start: {
            line: 398,
            column: 19
          },
          end: {
            line: 445,
            column: 9
          }
        },
        line: 398
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 426,
            column: 17
          },
          end: {
            line: 426,
            column: 18
          }
        },
        loc: {
          start: {
            line: 426,
            column: 29
          },
          end: {
            line: 439,
            column: 15
          }
        },
        line: 426
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 429,
            column: 34
          },
          end: {
            line: 429,
            column: 35
          }
        },
        loc: {
          start: {
            line: 429,
            column: 40
          },
          end: {
            line: 436,
            column: 21
          }
        },
        line: 429
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 448,
            column: 26
          },
          end: {
            line: 448,
            column: 27
          }
        },
        loc: {
          start: {
            line: 448,
            column: 42
          },
          end: {
            line: 468,
            column: 9
          }
        },
        line: 448
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 483,
            column: 11
          },
          end: {
            line: 483,
            column: 12
          }
        },
        loc: {
          start: {
            line: 483,
            column: 19
          },
          end: {
            line: 494,
            column: 9
          }
        },
        line: 483
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 599,
            column: 109
          },
          end: {
            line: 599,
            column: 110
          }
        },
        loc: {
          start: {
            line: 599,
            column: 117
          },
          end: {
            line: 645,
            column: 7
          }
        },
        line: 599
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 630,
            column: 31
          },
          end: {
            line: 630,
            column: 32
          }
        },
        loc: {
          start: {
            line: 630,
            column: 44
          },
          end: {
            line: 639,
            column: 13
          }
        },
        line: 630
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 697,
            column: 36
          },
          end: {
            line: 697,
            column: 37
          }
        },
        loc: {
          start: {
            line: 697,
            column: 42
          },
          end: {
            line: 699,
            column: 3
          }
        },
        line: 697
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 700,
            column: 39
          },
          end: {
            line: 700,
            column: 40
          }
        },
        loc: {
          start: {
            line: 700,
            column: 45
          },
          end: {
            line: 702,
            column: 3
          }
        },
        line: 700
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 703,
            column: 45
          },
          end: {
            line: 703,
            column: 46
          }
        },
        loc: {
          start: {
            line: 703,
            column: 51
          },
          end: {
            line: 720,
            column: 3
          }
        },
        line: 703
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 704,
            column: 119
          },
          end: {
            line: 704,
            column: 120
          }
        },
        loc: {
          start: {
            line: 704,
            column: 127
          },
          end: {
            line: 719,
            column: 5
          }
        },
        line: 704
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 5,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 5,
            column: 3
          }
        }, {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 5,
            column: 3
          }
        }],
        line: 3
      },
      '1': {
        loc: {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 15,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 15,
            column: 5
          }
        }, {
          start: {
            line: 13,
            column: 4
          },
          end: {
            line: 15,
            column: 5
          }
        }],
        line: 13
      },
      '2': {
        loc: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        }, {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 34,
            column: 5
          }
        }],
        line: 32
      },
      '3': {
        loc: {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        }, {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        }],
        line: 35
      },
      '4': {
        loc: {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 40,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 40,
            column: 5
          }
        }, {
          start: {
            line: 38,
            column: 4
          },
          end: {
            line: 40,
            column: 5
          }
        }],
        line: 38
      },
      '5': {
        loc: {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 44,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 44,
            column: 5
          }
        }, {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 44,
            column: 5
          }
        }],
        line: 42
      },
      '6': {
        loc: {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        }, {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        }],
        line: 45
      },
      '7': {
        loc: {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        }, {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        }],
        line: 49
      },
      '8': {
        loc: {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 92,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 92,
            column: 5
          }
        }, {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 92,
            column: 5
          }
        }],
        line: 90
      },
      '9': {
        loc: {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        }, {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        }],
        line: 93
      },
      '10': {
        loc: {
          start: {
            line: 93,
            column: 8
          },
          end: {
            line: 93,
            column: 39
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 93,
            column: 8
          },
          end: {
            line: 93,
            column: 13
          }
        }, {
          start: {
            line: 93,
            column: 17
          },
          end: {
            line: 93,
            column: 39
          }
        }],
        line: 93
      },
      '11': {
        loc: {
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 100,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 100,
            column: 5
          }
        }, {
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 100,
            column: 5
          }
        }],
        line: 96
      },
      '12': {
        loc: {
          start: {
            line: 98,
            column: 11
          },
          end: {
            line: 100,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 98,
            column: 11
          },
          end: {
            line: 100,
            column: 5
          }
        }, {
          start: {
            line: 98,
            column: 11
          },
          end: {
            line: 100,
            column: 5
          }
        }],
        line: 98
      },
      '13': {
        loc: {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        }, {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        }],
        line: 101
      },
      '14': {
        loc: {
          start: {
            line: 105,
            column: 4
          },
          end: {
            line: 107,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 105,
            column: 4
          },
          end: {
            line: 107,
            column: 5
          }
        }, {
          start: {
            line: 105,
            column: 4
          },
          end: {
            line: 107,
            column: 5
          }
        }],
        line: 105
      },
      '15': {
        loc: {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 111,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 111,
            column: 5
          }
        }, {
          start: {
            line: 109,
            column: 4
          },
          end: {
            line: 111,
            column: 5
          }
        }],
        line: 109
      },
      '16': {
        loc: {
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 120,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 120,
            column: 7
          }
        }, {
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 120,
            column: 7
          }
        }],
        line: 117
      },
      '17': {
        loc: {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 130,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 130,
            column: 5
          }
        }, {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 130,
            column: 5
          }
        }],
        line: 122
      },
      '18': {
        loc: {
          start: {
            line: 133,
            column: 6
          },
          end: {
            line: 135,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 133,
            column: 6
          },
          end: {
            line: 135,
            column: 7
          }
        }, {
          start: {
            line: 133,
            column: 6
          },
          end: {
            line: 135,
            column: 7
          }
        }],
        line: 133
      },
      '19': {
        loc: {
          start: {
            line: 133,
            column: 10
          },
          end: {
            line: 133,
            column: 82
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 133,
            column: 10
          },
          end: {
            line: 133,
            column: 31
          }
        }, {
          start: {
            line: 133,
            column: 36
          },
          end: {
            line: 133,
            column: 57
          }
        }, {
          start: {
            line: 133,
            column: 61
          },
          end: {
            line: 133,
            column: 81
          }
        }],
        line: 133
      },
      '20': {
        loc: {
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 149,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 149,
            column: 5
          }
        }, {
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 149,
            column: 5
          }
        }],
        line: 146
      },
      '21': {
        loc: {
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 157,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 157,
            column: 5
          }
        }, {
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 157,
            column: 5
          }
        }],
        line: 155
      },
      '22': {
        loc: {
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 167,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 167,
            column: 5
          }
        }, {
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 167,
            column: 5
          }
        }],
        line: 165
      },
      '23': {
        loc: {
          start: {
            line: 173,
            column: 8
          },
          end: {
            line: 176,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 173,
            column: 8
          },
          end: {
            line: 176,
            column: 9
          }
        }, {
          start: {
            line: 173,
            column: 8
          },
          end: {
            line: 176,
            column: 9
          }
        }],
        line: 173
      },
      '24': {
        loc: {
          start: {
            line: 203,
            column: 8
          },
          end: {
            line: 205,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 203,
            column: 8
          },
          end: {
            line: 205,
            column: 9
          }
        }, {
          start: {
            line: 203,
            column: 8
          },
          end: {
            line: 205,
            column: 9
          }
        }],
        line: 203
      },
      '25': {
        loc: {
          start: {
            line: 207,
            column: 8
          },
          end: {
            line: 216,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 207,
            column: 8
          },
          end: {
            line: 216,
            column: 9
          }
        }, {
          start: {
            line: 207,
            column: 8
          },
          end: {
            line: 216,
            column: 9
          }
        }],
        line: 207
      },
      '26': {
        loc: {
          start: {
            line: 211,
            column: 12
          },
          end: {
            line: 214,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 211,
            column: 12
          },
          end: {
            line: 214,
            column: 13
          }
        }, {
          start: {
            line: 211,
            column: 12
          },
          end: {
            line: 214,
            column: 13
          }
        }],
        line: 211
      },
      '27': {
        loc: {
          start: {
            line: 223,
            column: 17
          },
          end: {
            line: 223,
            column: 79
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 223,
            column: 46
          },
          end: {
            line: 223,
            column: 75
          }
        }, {
          start: {
            line: 223,
            column: 78
          },
          end: {
            line: 223,
            column: 79
          }
        }],
        line: 223
      },
      '28': {
        loc: {
          start: {
            line: 236,
            column: 14
          },
          end: {
            line: 239,
            column: 15
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 236,
            column: 14
          },
          end: {
            line: 239,
            column: 15
          }
        }, {
          start: {
            line: 236,
            column: 14
          },
          end: {
            line: 239,
            column: 15
          }
        }],
        line: 236
      },
      '29': {
        loc: {
          start: {
            line: 250,
            column: 10
          },
          end: {
            line: 252,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 250,
            column: 10
          },
          end: {
            line: 252,
            column: 11
          }
        }, {
          start: {
            line: 250,
            column: 10
          },
          end: {
            line: 252,
            column: 11
          }
        }],
        line: 250
      },
      '30': {
        loc: {
          start: {
            line: 253,
            column: 10
          },
          end: {
            line: 255,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 253,
            column: 10
          },
          end: {
            line: 255,
            column: 11
          }
        }, {
          start: {
            line: 253,
            column: 10
          },
          end: {
            line: 255,
            column: 11
          }
        }],
        line: 253
      },
      '31': {
        loc: {
          start: {
            line: 256,
            column: 10
          },
          end: {
            line: 258,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 256,
            column: 10
          },
          end: {
            line: 258,
            column: 11
          }
        }, {
          start: {
            line: 256,
            column: 10
          },
          end: {
            line: 258,
            column: 11
          }
        }],
        line: 256
      },
      '32': {
        loc: {
          start: {
            line: 269,
            column: 12
          },
          end: {
            line: 271,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 269,
            column: 12
          },
          end: {
            line: 271,
            column: 13
          }
        }, {
          start: {
            line: 269,
            column: 12
          },
          end: {
            line: 271,
            column: 13
          }
        }],
        line: 269
      },
      '33': {
        loc: {
          start: {
            line: 272,
            column: 12
          },
          end: {
            line: 274,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 272,
            column: 12
          },
          end: {
            line: 274,
            column: 13
          }
        }, {
          start: {
            line: 272,
            column: 12
          },
          end: {
            line: 274,
            column: 13
          }
        }],
        line: 272
      },
      '34': {
        loc: {
          start: {
            line: 275,
            column: 12
          },
          end: {
            line: 277,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 275,
            column: 12
          },
          end: {
            line: 277,
            column: 13
          }
        }, {
          start: {
            line: 275,
            column: 12
          },
          end: {
            line: 277,
            column: 13
          }
        }],
        line: 275
      },
      '35': {
        loc: {
          start: {
            line: 278,
            column: 12
          },
          end: {
            line: 280,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 278,
            column: 12
          },
          end: {
            line: 280,
            column: 13
          }
        }, {
          start: {
            line: 278,
            column: 12
          },
          end: {
            line: 280,
            column: 13
          }
        }],
        line: 278
      },
      '36': {
        loc: {
          start: {
            line: 292,
            column: 12
          },
          end: {
            line: 294,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 292,
            column: 12
          },
          end: {
            line: 294,
            column: 13
          }
        }, {
          start: {
            line: 292,
            column: 12
          },
          end: {
            line: 294,
            column: 13
          }
        }],
        line: 292
      },
      '37': {
        loc: {
          start: {
            line: 295,
            column: 12
          },
          end: {
            line: 297,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 295,
            column: 12
          },
          end: {
            line: 297,
            column: 13
          }
        }, {
          start: {
            line: 295,
            column: 12
          },
          end: {
            line: 297,
            column: 13
          }
        }],
        line: 295
      },
      '38': {
        loc: {
          start: {
            line: 298,
            column: 12
          },
          end: {
            line: 300,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 298,
            column: 12
          },
          end: {
            line: 300,
            column: 13
          }
        }, {
          start: {
            line: 298,
            column: 12
          },
          end: {
            line: 300,
            column: 13
          }
        }],
        line: 298
      },
      '39': {
        loc: {
          start: {
            line: 301,
            column: 12
          },
          end: {
            line: 303,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 301,
            column: 12
          },
          end: {
            line: 303,
            column: 13
          }
        }, {
          start: {
            line: 301,
            column: 12
          },
          end: {
            line: 303,
            column: 13
          }
        }],
        line: 301
      },
      '40': {
        loc: {
          start: {
            line: 311,
            column: 8
          },
          end: {
            line: 322,
            column: 9
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 312,
            column: 10
          },
          end: {
            line: 312,
            column: 17
          }
        }, {
          start: {
            line: 312,
            column: 18
          },
          end: {
            line: 314,
            column: 18
          }
        }, {
          start: {
            line: 315,
            column: 10
          },
          end: {
            line: 315,
            column: 17
          }
        }, {
          start: {
            line: 315,
            column: 18
          },
          end: {
            line: 317,
            column: 18
          }
        }, {
          start: {
            line: 318,
            column: 10
          },
          end: {
            line: 318,
            column: 17
          }
        }, {
          start: {
            line: 318,
            column: 18
          },
          end: {
            line: 320,
            column: 18
          }
        }, {
          start: {
            line: 321,
            column: 10
          },
          end: {
            line: 321,
            column: 18
          }
        }],
        line: 311
      },
      '41': {
        loc: {
          start: {
            line: 325,
            column: 24
          },
          end: {
            line: 325,
            column: 33
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 325,
            column: 24
          },
          end: {
            line: 325,
            column: 28
          }
        }, {
          start: {
            line: 325,
            column: 32
          },
          end: {
            line: 325,
            column: 33
          }
        }],
        line: 325
      },
      '42': {
        loc: {
          start: {
            line: 330,
            column: 12
          },
          end: {
            line: 335,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 330,
            column: 12
          },
          end: {
            line: 335,
            column: 13
          }
        }, {
          start: {
            line: 330,
            column: 12
          },
          end: {
            line: 335,
            column: 13
          }
        }],
        line: 330
      },
      '43': {
        loc: {
          start: {
            line: 330,
            column: 16
          },
          end: {
            line: 330,
            column: 118
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 330,
            column: 16
          },
          end: {
            line: 330,
            column: 65
          }
        }, {
          start: {
            line: 330,
            column: 69
          },
          end: {
            line: 330,
            column: 118
          }
        }],
        line: 330
      },
      '44': {
        loc: {
          start: {
            line: 337,
            column: 10
          },
          end: {
            line: 339,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 337,
            column: 10
          },
          end: {
            line: 339,
            column: 11
          }
        }, {
          start: {
            line: 337,
            column: 10
          },
          end: {
            line: 339,
            column: 11
          }
        }],
        line: 337
      },
      '45': {
        loc: {
          start: {
            line: 337,
            column: 14
          },
          end: {
            line: 337,
            column: 32
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 337,
            column: 14
          },
          end: {
            line: 337,
            column: 21
          }
        }, {
          start: {
            line: 337,
            column: 25
          },
          end: {
            line: 337,
            column: 32
          }
        }],
        line: 337
      },
      '46': {
        loc: {
          start: {
            line: 341,
            column: 20
          },
          end: {
            line: 341,
            column: 114
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 341,
            column: 43
          },
          end: {
            line: 341,
            column: 49
          }
        }, {
          start: {
            line: 341,
            column: 53
          },
          end: {
            line: 341,
            column: 113
          }
        }],
        line: 341
      },
      '47': {
        loc: {
          start: {
            line: 353,
            column: 37
          },
          end: {
            line: 353,
            column: 46
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 353,
            column: 37
          },
          end: {
            line: 353,
            column: 41
          }
        }, {
          start: {
            line: 353,
            column: 45
          },
          end: {
            line: 353,
            column: 46
          }
        }],
        line: 353
      },
      '48': {
        loc: {
          start: {
            line: 373,
            column: 21
          },
          end: {
            line: 373,
            column: 35
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 373,
            column: 21
          },
          end: {
            line: 373,
            column: 29
          }
        }, {
          start: {
            line: 373,
            column: 33
          },
          end: {
            line: 373,
            column: 35
          }
        }],
        line: 373
      },
      '49': {
        loc: {
          start: {
            line: 374,
            column: 18
          },
          end: {
            line: 374,
            column: 30
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 374,
            column: 18
          },
          end: {
            line: 374,
            column: 24
          }
        }, {
          start: {
            line: 374,
            column: 28
          },
          end: {
            line: 374,
            column: 30
          }
        }],
        line: 374
      },
      '50': {
        loc: {
          start: {
            line: 377,
            column: 29
          },
          end: {
            line: 377,
            column: 41
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 377,
            column: 29
          },
          end: {
            line: 377,
            column: 35
          }
        }, {
          start: {
            line: 377,
            column: 39
          },
          end: {
            line: 377,
            column: 41
          }
        }],
        line: 377
      },
      '51': {
        loc: {
          start: {
            line: 377,
            column: 54
          },
          end: {
            line: 377,
            column: 66
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 377,
            column: 54
          },
          end: {
            line: 377,
            column: 60
          }
        }, {
          start: {
            line: 377,
            column: 64
          },
          end: {
            line: 377,
            column: 66
          }
        }],
        line: 377
      },
      '52': {
        loc: {
          start: {
            line: 400,
            column: 12
          },
          end: {
            line: 402,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 400,
            column: 12
          },
          end: {
            line: 402,
            column: 13
          }
        }, {
          start: {
            line: 400,
            column: 12
          },
          end: {
            line: 402,
            column: 13
          }
        }],
        line: 400
      },
      '53': {
        loc: {
          start: {
            line: 405,
            column: 14
          },
          end: {
            line: 408,
            column: 15
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 405,
            column: 14
          },
          end: {
            line: 408,
            column: 15
          }
        }, {
          start: {
            line: 405,
            column: 14
          },
          end: {
            line: 408,
            column: 15
          }
        }],
        line: 405
      },
      '54': {
        loc: {
          start: {
            line: 412,
            column: 12
          },
          end: {
            line: 441,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 412,
            column: 12
          },
          end: {
            line: 441,
            column: 13
          }
        }, {
          start: {
            line: 412,
            column: 12
          },
          end: {
            line: 441,
            column: 13
          }
        }],
        line: 412
      },
      '55': {
        loc: {
          start: {
            line: 414,
            column: 14
          },
          end: {
            line: 416,
            column: 15
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 414,
            column: 14
          },
          end: {
            line: 416,
            column: 15
          }
        }, {
          start: {
            line: 414,
            column: 14
          },
          end: {
            line: 416,
            column: 15
          }
        }],
        line: 414
      },
      '56': {
        loc: {
          start: {
            line: 450,
            column: 22
          },
          end: {
            line: 450,
            column: 37
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 450,
            column: 22
          },
          end: {
            line: 450,
            column: 31
          }
        }, {
          start: {
            line: 450,
            column: 35
          },
          end: {
            line: 450,
            column: 37
          }
        }],
        line: 450
      },
      '57': {
        loc: {
          start: {
            line: 455,
            column: 14
          },
          end: {
            line: 457,
            column: 15
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 455,
            column: 14
          },
          end: {
            line: 457,
            column: 15
          }
        }, {
          start: {
            line: 455,
            column: 14
          },
          end: {
            line: 457,
            column: 15
          }
        }],
        line: 455
      },
      '58': {
        loc: {
          start: {
            line: 459,
            column: 14
          },
          end: {
            line: 461,
            column: 15
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 459,
            column: 14
          },
          end: {
            line: 461,
            column: 15
          }
        }, {
          start: {
            line: 459,
            column: 14
          },
          end: {
            line: 461,
            column: 15
          }
        }],
        line: 459
      },
      '59': {
        loc: {
          start: {
            line: 491,
            column: 10
          },
          end: {
            line: 493,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 491,
            column: 10
          },
          end: {
            line: 493,
            column: 11
          }
        }, {
          start: {
            line: 491,
            column: 10
          },
          end: {
            line: 493,
            column: 11
          }
        }],
        line: 491
      },
      '60': {
        loc: {
          start: {
            line: 500,
            column: 10
          },
          end: {
            line: 502,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 500,
            column: 10
          },
          end: {
            line: 502,
            column: 11
          }
        }, {
          start: {
            line: 500,
            column: 10
          },
          end: {
            line: 502,
            column: 11
          }
        }],
        line: 500
      },
      '61': {
        loc: {
          start: {
            line: 522,
            column: 21
          },
          end: {
            line: 522,
            column: 45
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 522,
            column: 40
          },
          end: {
            line: 522,
            column: 41
          }
        }, {
          start: {
            line: 522,
            column: 44
          },
          end: {
            line: 522,
            column: 45
          }
        }],
        line: 522
      },
      '62': {
        loc: {
          start: {
            line: 522,
            column: 50
          },
          end: {
            line: 522,
            column: 78
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 522,
            column: 73
          },
          end: {
            line: 522,
            column: 74
          }
        }, {
          start: {
            line: 522,
            column: 77
          },
          end: {
            line: 522,
            column: 78
          }
        }],
        line: 522
      },
      '63': {
        loc: {
          start: {
            line: 523,
            column: 6
          },
          end: {
            line: 539,
            column: 7
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 524,
            column: 8
          },
          end: {
            line: 526,
            column: 16
          }
        }, {
          start: {
            line: 527,
            column: 8
          },
          end: {
            line: 529,
            column: 16
          }
        }, {
          start: {
            line: 530,
            column: 8
          },
          end: {
            line: 532,
            column: 16
          }
        }, {
          start: {
            line: 533,
            column: 8
          },
          end: {
            line: 535,
            column: 16
          }
        }, {
          start: {
            line: 536,
            column: 8
          },
          end: {
            line: 538,
            column: 16
          }
        }],
        line: 523
      },
      '64': {
        loc: {
          start: {
            line: 546,
            column: 6
          },
          end: {
            line: 548,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 546,
            column: 6
          },
          end: {
            line: 548,
            column: 7
          }
        }, {
          start: {
            line: 546,
            column: 6
          },
          end: {
            line: 548,
            column: 7
          }
        }],
        line: 546
      },
      '65': {
        loc: {
          start: {
            line: 546,
            column: 10
          },
          end: {
            line: 546,
            column: 82
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 546,
            column: 10
          },
          end: {
            line: 546,
            column: 40
          }
        }, {
          start: {
            line: 546,
            column: 44
          },
          end: {
            line: 546,
            column: 82
          }
        }],
        line: 546
      },
      '66': {
        loc: {
          start: {
            line: 551,
            column: 6
          },
          end: {
            line: 553,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 551,
            column: 6
          },
          end: {
            line: 553,
            column: 7
          }
        }, {
          start: {
            line: 551,
            column: 6
          },
          end: {
            line: 553,
            column: 7
          }
        }],
        line: 551
      },
      '67': {
        loc: {
          start: {
            line: 551,
            column: 10
          },
          end: {
            line: 551,
            column: 82
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 551,
            column: 10
          },
          end: {
            line: 551,
            column: 40
          }
        }, {
          start: {
            line: 551,
            column: 44
          },
          end: {
            line: 551,
            column: 82
          }
        }],
        line: 551
      },
      '68': {
        loc: {
          start: {
            line: 556,
            column: 6
          },
          end: {
            line: 558,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 556,
            column: 6
          },
          end: {
            line: 558,
            column: 7
          }
        }, {
          start: {
            line: 556,
            column: 6
          },
          end: {
            line: 558,
            column: 7
          }
        }],
        line: 556
      },
      '69': {
        loc: {
          start: {
            line: 556,
            column: 10
          },
          end: {
            line: 556,
            column: 82
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 556,
            column: 10
          },
          end: {
            line: 556,
            column: 40
          }
        }, {
          start: {
            line: 556,
            column: 44
          },
          end: {
            line: 556,
            column: 82
          }
        }],
        line: 556
      },
      '70': {
        loc: {
          start: {
            line: 562,
            column: 21
          },
          end: {
            line: 578,
            column: 7
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 562,
            column: 27
          },
          end: {
            line: 572,
            column: 7
          }
        }, {
          start: {
            line: 572,
            column: 10
          },
          end: {
            line: 578,
            column: 7
          }
        }],
        line: 562
      },
      '71': {
        loc: {
          start: {
            line: 579,
            column: 19
          },
          end: {
            line: 579,
            column: 33
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 579,
            column: 19
          },
          end: {
            line: 579,
            column: 27
          }
        }, {
          start: {
            line: 579,
            column: 31
          },
          end: {
            line: 579,
            column: 33
          }
        }],
        line: 579
      },
      '72': {
        loc: {
          start: {
            line: 580,
            column: 16
          },
          end: {
            line: 580,
            column: 28
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 580,
            column: 16
          },
          end: {
            line: 580,
            column: 22
          }
        }, {
          start: {
            line: 580,
            column: 26
          },
          end: {
            line: 580,
            column: 28
          }
        }],
        line: 580
      },
      '73': {
        loc: {
          start: {
            line: 583,
            column: 8
          },
          end: {
            line: 587,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 583,
            column: 8
          },
          end: {
            line: 587,
            column: 9
          }
        }, {
          start: {
            line: 583,
            column: 8
          },
          end: {
            line: 587,
            column: 9
          }
        }],
        line: 583
      },
      '74': {
        loc: {
          start: {
            line: 583,
            column: 13
          },
          end: {
            line: 583,
            column: 25
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 583,
            column: 13
          },
          end: {
            line: 583,
            column: 19
          }
        }, {
          start: {
            line: 583,
            column: 23
          },
          end: {
            line: 583,
            column: 25
          }
        }],
        line: 583
      },
      '75': {
        loc: {
          start: {
            line: 584,
            column: 27
          },
          end: {
            line: 584,
            column: 39
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 584,
            column: 27
          },
          end: {
            line: 584,
            column: 33
          }
        }, {
          start: {
            line: 584,
            column: 37
          },
          end: {
            line: 584,
            column: 39
          }
        }],
        line: 584
      },
      '76': {
        loc: {
          start: {
            line: 585,
            column: 29
          },
          end: {
            line: 585,
            column: 41
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 585,
            column: 29
          },
          end: {
            line: 585,
            column: 35
          }
        }, {
          start: {
            line: 585,
            column: 39
          },
          end: {
            line: 585,
            column: 41
          }
        }],
        line: 585
      },
      '77': {
        loc: {
          start: {
            line: 592,
            column: 6
          },
          end: {
            line: 597,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 592,
            column: 6
          },
          end: {
            line: 597,
            column: 7
          }
        }, {
          start: {
            line: 592,
            column: 6
          },
          end: {
            line: 597,
            column: 7
          }
        }],
        line: 592
      },
      '78': {
        loc: {
          start: {
            line: 603,
            column: 10
          },
          end: {
            line: 640,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 603,
            column: 10
          },
          end: {
            line: 640,
            column: 11
          }
        }, {
          start: {
            line: 603,
            column: 10
          },
          end: {
            line: 640,
            column: 11
          }
        }],
        line: 603
      },
      '79': {
        loc: {
          start: {
            line: 603,
            column: 14
          },
          end: {
            line: 603,
            column: 56
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 603,
            column: 14
          },
          end: {
            line: 603,
            column: 32
          }
        }, {
          start: {
            line: 603,
            column: 36
          },
          end: {
            line: 603,
            column: 56
          }
        }],
        line: 603
      },
      '80': {
        loc: {
          start: {
            line: 631,
            column: 14
          },
          end: {
            line: 638,
            column: 15
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 631,
            column: 14
          },
          end: {
            line: 638,
            column: 15
          }
        }, {
          start: {
            line: 631,
            column: 14
          },
          end: {
            line: 638,
            column: 15
          }
        }],
        line: 631
      },
      '81': {
        loc: {
          start: {
            line: 632,
            column: 29
          },
          end: {
            line: 632,
            column: 50
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 632,
            column: 29
          },
          end: {
            line: 632,
            column: 42
          }
        }, {
          start: {
            line: 632,
            column: 46
          },
          end: {
            line: 632,
            column: 50
          }
        }],
        line: 632
      },
      '82': {
        loc: {
          start: {
            line: 642,
            column: 8
          },
          end: {
            line: 644,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 642,
            column: 8
          },
          end: {
            line: 644,
            column: 9
          }
        }, {
          start: {
            line: 642,
            column: 8
          },
          end: {
            line: 644,
            column: 9
          }
        }],
        line: 642
      },
      '83': {
        loc: {
          start: {
            line: 642,
            column: 12
          },
          end: {
            line: 642,
            column: 83
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 642,
            column: 12
          },
          end: {
            line: 642,
            column: 42
          }
        }, {
          start: {
            line: 642,
            column: 46
          },
          end: {
            line: 642,
            column: 83
          }
        }],
        line: 642
      },
      '84': {
        loc: {
          start: {
            line: 650,
            column: 6
          },
          end: {
            line: 652,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 650,
            column: 6
          },
          end: {
            line: 652,
            column: 7
          }
        }, {
          start: {
            line: 650,
            column: 6
          },
          end: {
            line: 652,
            column: 7
          }
        }],
        line: 650
      },
      '85': {
        loc: {
          start: {
            line: 655,
            column: 6
          },
          end: {
            line: 658,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 655,
            column: 6
          },
          end: {
            line: 658,
            column: 7
          }
        }, {
          start: {
            line: 655,
            column: 6
          },
          end: {
            line: 658,
            column: 7
          }
        }],
        line: 655
      },
      '86': {
        loc: {
          start: {
            line: 661,
            column: 21
          },
          end: {
            line: 661,
            column: 83
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 661,
            column: 50
          },
          end: {
            line: 661,
            column: 79
          }
        }, {
          start: {
            line: 661,
            column: 82
          },
          end: {
            line: 661,
            column: 83
          }
        }],
        line: 661
      },
      '87': {
        loc: {
          start: {
            line: 661,
            column: 85
          },
          end: {
            line: 661,
            column: 154
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 661,
            column: 116
          },
          end: {
            line: 661,
            column: 150
          }
        }, {
          start: {
            line: 661,
            column: 153
          },
          end: {
            line: 661,
            column: 154
          }
        }],
        line: 661
      },
      '88': {
        loc: {
          start: {
            line: 668,
            column: 8
          },
          end: {
            line: 671,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 668,
            column: 8
          },
          end: {
            line: 671,
            column: 9
          }
        }, {
          start: {
            line: 668,
            column: 8
          },
          end: {
            line: 671,
            column: 9
          }
        }],
        line: 668
      },
      '89': {
        loc: {
          start: {
            line: 678,
            column: 6
          },
          end: {
            line: 680,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 678,
            column: 6
          },
          end: {
            line: 680,
            column: 7
          }
        }, {
          start: {
            line: 678,
            column: 6
          },
          end: {
            line: 680,
            column: 7
          }
        }],
        line: 678
      },
      '90': {
        loc: {
          start: {
            line: 712,
            column: 35
          },
          end: {
            line: 712,
            column: 83
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 712,
            column: 35
          },
          end: {
            line: 712,
            column: 63
          }
        }, {
          start: {
            line: 712,
            column: 67
          },
          end: {
            line: 712,
            column: 83
          }
        }],
        line: 712
      },
      '91': {
        loc: {
          start: {
            line: 714,
            column: 8
          },
          end: {
            line: 716,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 714,
            column: 8
          },
          end: {
            line: 716,
            column: 9
          }
        }, {
          start: {
            line: 714,
            column: 8
          },
          end: {
            line: 716,
            column: 9
          }
        }],
        line: 714
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0,
      '146': 0,
      '147': 0,
      '148': 0,
      '149': 0,
      '150': 0,
      '151': 0,
      '152': 0,
      '153': 0,
      '154': 0,
      '155': 0,
      '156': 0,
      '157': 0,
      '158': 0,
      '159': 0,
      '160': 0,
      '161': 0,
      '162': 0,
      '163': 0,
      '164': 0,
      '165': 0,
      '166': 0,
      '167': 0,
      '168': 0,
      '169': 0,
      '170': 0,
      '171': 0,
      '172': 0,
      '173': 0,
      '174': 0,
      '175': 0,
      '176': 0,
      '177': 0,
      '178': 0,
      '179': 0,
      '180': 0,
      '181': 0,
      '182': 0,
      '183': 0,
      '184': 0,
      '185': 0,
      '186': 0,
      '187': 0,
      '188': 0,
      '189': 0,
      '190': 0,
      '191': 0,
      '192': 0,
      '193': 0,
      '194': 0,
      '195': 0,
      '196': 0,
      '197': 0,
      '198': 0,
      '199': 0,
      '200': 0,
      '201': 0,
      '202': 0,
      '203': 0,
      '204': 0,
      '205': 0,
      '206': 0,
      '207': 0,
      '208': 0,
      '209': 0,
      '210': 0,
      '211': 0,
      '212': 0,
      '213': 0,
      '214': 0,
      '215': 0,
      '216': 0,
      '217': 0,
      '218': 0,
      '219': 0,
      '220': 0,
      '221': 0,
      '222': 0,
      '223': 0,
      '224': 0,
      '225': 0,
      '226': 0,
      '227': 0,
      '228': 0,
      '229': 0,
      '230': 0,
      '231': 0,
      '232': 0,
      '233': 0,
      '234': 0,
      '235': 0,
      '236': 0,
      '237': 0,
      '238': 0,
      '239': 0,
      '240': 0,
      '241': 0,
      '242': 0,
      '243': 0,
      '244': 0,
      '245': 0,
      '246': 0,
      '247': 0,
      '248': 0,
      '249': 0,
      '250': 0,
      '251': 0,
      '252': 0,
      '253': 0,
      '254': 0,
      '255': 0,
      '256': 0,
      '257': 0,
      '258': 0,
      '259': 0,
      '260': 0,
      '261': 0,
      '262': 0,
      '263': 0,
      '264': 0,
      '265': 0,
      '266': 0,
      '267': 0,
      '268': 0,
      '269': 0,
      '270': 0,
      '271': 0,
      '272': 0,
      '273': 0,
      '274': 0,
      '275': 0,
      '276': 0,
      '277': 0,
      '278': 0,
      '279': 0,
      '280': 0,
      '281': 0,
      '282': 0,
      '283': 0,
      '284': 0,
      '285': 0,
      '286': 0,
      '287': 0,
      '288': 0,
      '289': 0,
      '290': 0,
      '291': 0,
      '292': 0,
      '293': 0,
      '294': 0,
      '295': 0,
      '296': 0,
      '297': 0,
      '298': 0,
      '299': 0,
      '300': 0,
      '301': 0,
      '302': 0,
      '303': 0,
      '304': 0,
      '305': 0,
      '306': 0,
      '307': 0,
      '308': 0,
      '309': 0,
      '310': 0,
      '311': 0,
      '312': 0,
      '313': 0,
      '314': 0,
      '315': 0,
      '316': 0,
      '317': 0,
      '318': 0,
      '319': 0,
      '320': 0,
      '321': 0,
      '322': 0,
      '323': 0,
      '324': 0,
      '325': 0,
      '326': 0,
      '327': 0,
      '328': 0,
      '329': 0,
      '330': 0,
      '331': 0,
      '332': 0,
      '333': 0,
      '334': 0,
      '335': 0,
      '336': 0,
      '337': 0,
      '338': 0,
      '339': 0,
      '340': 0,
      '341': 0,
      '342': 0,
      '343': 0,
      '344': 0,
      '345': 0,
      '346': 0,
      '347': 0,
      '348': 0,
      '349': 0,
      '350': 0,
      '351': 0,
      '352': 0,
      '353': 0,
      '354': 0,
      '355': 0,
      '356': 0,
      '357': 0,
      '358': 0,
      '359': 0,
      '360': 0,
      '361': 0,
      '362': 0,
      '363': 0,
      '364': 0,
      '365': 0,
      '366': 0,
      '367': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0],
      '26': [0, 0],
      '27': [0, 0],
      '28': [0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0, 0],
      '32': [0, 0],
      '33': [0, 0],
      '34': [0, 0],
      '35': [0, 0],
      '36': [0, 0],
      '37': [0, 0],
      '38': [0, 0],
      '39': [0, 0],
      '40': [0, 0, 0, 0, 0, 0, 0],
      '41': [0, 0],
      '42': [0, 0],
      '43': [0, 0],
      '44': [0, 0],
      '45': [0, 0],
      '46': [0, 0],
      '47': [0, 0],
      '48': [0, 0],
      '49': [0, 0],
      '50': [0, 0],
      '51': [0, 0],
      '52': [0, 0],
      '53': [0, 0],
      '54': [0, 0],
      '55': [0, 0],
      '56': [0, 0],
      '57': [0, 0],
      '58': [0, 0],
      '59': [0, 0],
      '60': [0, 0],
      '61': [0, 0],
      '62': [0, 0],
      '63': [0, 0, 0, 0, 0],
      '64': [0, 0],
      '65': [0, 0],
      '66': [0, 0],
      '67': [0, 0],
      '68': [0, 0],
      '69': [0, 0],
      '70': [0, 0],
      '71': [0, 0],
      '72': [0, 0],
      '73': [0, 0],
      '74': [0, 0],
      '75': [0, 0],
      '76': [0, 0],
      '77': [0, 0],
      '78': [0, 0],
      '79': [0, 0],
      '80': [0, 0],
      '81': [0, 0],
      '82': [0, 0],
      '83': [0, 0],
      '84': [0, 0],
      '85': [0, 0],
      '86': [0, 0],
      '87': [0, 0],
      '88': [0, 0],
      '89': [0, 0],
      '90': [0, 0],
      '91': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

cov_24axaiejip.s[0]++;
angular.module('app').controller('indicatorMapCtrl', function ($scope, $stateParams, $deltahttp, $deltaChampPerso, SweetAlert, $deltaActor, $rootScope, $translate, $deltaPlanLogique, $deltaTypeIndicateur, $deltaGeoLevel, $deltaLogLevel, $deltaUnite, $CRUDService, $log, $deltadate, $filter) {
  cov_24axaiejip.f[0]++;
  cov_24axaiejip.s[1]++;

  $rootScope.processPageRight('3_2');
  cov_24axaiejip.s[2]++;
  if ($rootScope.global_access_page_denied) {
    cov_24axaiejip.b[0][0]++;
    cov_24axaiejip.s[3]++;

    return;
  } else {
    cov_24axaiejip.b[0][1]++;
  }
  cov_24axaiejip.s[4]++;
  $scope.from = $stateParams.from;

  var PATH = (cov_24axaiejip.s[5]++, 'Indicateurs');
  var PATHVP = (cov_24axaiejip.s[6]++, 'ValeursPossible');
  var PATHINDIC = (cov_24axaiejip.s[7]++, 'DecoupageIndic');
  var PATHGLOBAL = (cov_24axaiejip.s[8]++, 'DecoupageGlobalIndic');
  cov_24axaiejip.s[9]++;
  $scope.getGlobalValue = function (indicItem) {
    cov_24axaiejip.f[1]++;
    cov_24axaiejip.s[10]++;

    if (!indicItem) {
      cov_24axaiejip.b[1][0]++;
      cov_24axaiejip.s[11]++;

      return;
    } else {
      cov_24axaiejip.b[1][1]++;
    }
    cov_24axaiejip.s[12]++;
    $scope.glovalValue = {};
    cov_24axaiejip.s[13]++;
    $CRUDService.getAll(PATHGLOBAL, { get: 'all_global', idcl: indicItem.CODE_CL, id: indicItem.id }, function (data) {
      cov_24axaiejip.f[2]++;
      cov_24axaiejip.s[14]++;

      try {
        cov_24axaiejip.s[15]++;

        data.c = eval(data.c);
      } catch (ex) {
        cov_24axaiejip.s[16]++;

        data.c = null;
      }
      cov_24axaiejip.s[17]++;
      try {
        cov_24axaiejip.s[18]++;

        data.r = eval(data.r);
      } catch (ex) {
        cov_24axaiejip.s[19]++;

        data.r = null;
      }
      cov_24axaiejip.s[20]++;
      $scope.glovalValue = data;
    });
  };
  cov_24axaiejip.s[21]++;
  $scope.getIndicateurLabel = function (item) {
    cov_24axaiejip.f[3]++;
    cov_24axaiejip.s[22]++;

    if (!item) {
      cov_24axaiejip.b[2][0]++;
      cov_24axaiejip.s[23]++;

      return '';
    } else {
      cov_24axaiejip.b[2][1]++;
    }
    cov_24axaiejip.s[24]++;
    if (!item.LIBELLE_C_INDIC_ENG) {
      cov_24axaiejip.b[3][0]++;
      cov_24axaiejip.s[25]++;

      return item.LIBELLE_C_INDIC;
    } else {
      cov_24axaiejip.b[3][1]++;
    }
    cov_24axaiejip.s[26]++;
    if (item.LIBELLE_C_INDIC_ENG.trim() == '') {
      cov_24axaiejip.b[4][0]++;
      cov_24axaiejip.s[27]++;

      return item.LIBELLE_C_INDIC;
    } else {
      cov_24axaiejip.b[4][1]++;
    }

    cov_24axaiejip.s[28]++;
    if (!item.LIBELLE_C_INDIC) {
      cov_24axaiejip.b[5][0]++;
      cov_24axaiejip.s[29]++;

      return item.LIBELLE_C_INDIC_ENG;
    } else {
      cov_24axaiejip.b[5][1]++;
    }
    cov_24axaiejip.s[30]++;
    if (item.LIBELLE_C_INDIC.trim() == '') {
      cov_24axaiejip.b[6][0]++;
      cov_24axaiejip.s[31]++;

      return item.LIBELLE_C_INDIC_ENG;
    } else {
      cov_24axaiejip.b[6][1]++;
    }

    cov_24axaiejip.s[32]++;
    if ($rootScope.language.id == 'en') {
      cov_24axaiejip.b[7][0]++;
      cov_24axaiejip.s[33]++;

      return item.LIBELLE_C_INDIC_ENG;
    } else {
      cov_24axaiejip.b[7][1]++;
    }
    cov_24axaiejip.s[34]++;
    return item.LIBELLE_C_INDIC;
  };
  cov_24axaiejip.s[35]++;
  $scope.idcl = $stateParams.idcl;
  cov_24axaiejip.s[36]++;
  $scope.dashboard = {
    listSuivi: [],
    listSuiviPeriod: [],
    NG: null,
    listYear: [],
    yearSuivi: null,
    listPeriodSuivi: [],
    periodSuivi: null,
    listPeriodfollow: [],
    periodFollow: null,
    yearFollow: null,
    listFollow: [],
    display_glob: true,
    display_year: true,
    display_period: true,
    display_codeloc: false,
    typeFollow: false,
    displayedGraphe: $rootScope.personalData.grapheIndicateur + 1,
    doughnutDataPlan: [],
    doughnutDataReal: [],
    listPD: [{ name: $translate.instant('COMMON.PERIOD'), id: '1' }, { name: $translate.instant('COMMON.YEAR'), id: '2' }, { name: 'Global', id: '3' }],
    listGraph: [{ id: 0, title: $translate.instant('COMMON.LINECHART') }, { id: 1, title: $translate.instant('COMMON.BARCHART') }, { id: 2, title: $translate.instant('COMMON.PIECHART') }, { id: 3, title: $translate.instant('COMMON.POLARCHART') }]
  };
  cov_24axaiejip.s[37]++;
  $scope.openDashboard = function (item) {
    cov_24axaiejip.f[4]++;
    cov_24axaiejip.s[38]++;

    item.imageUrl = $deltahttp.getIndicatorRespositoy(item.id);
    cov_24axaiejip.s[39]++;
    item.legendImageUrl = $deltahttp.getIndicatorRespositoryLegend(item.id);
    cov_24axaiejip.s[40]++;
    if ($scope.isOpen) {
      cov_24axaiejip.b[8][0]++;
      cov_24axaiejip.s[41]++;

      return;
    } else {
      cov_24axaiejip.b[8][1]++;
    }
    cov_24axaiejip.s[42]++;
    if ((cov_24axaiejip.b[10][0]++, !item) && (cov_24axaiejip.b[10][1]++, !$scope.dashboard.item)) {
      cov_24axaiejip.b[9][0]++;
      cov_24axaiejip.s[43]++;

      return;
    } else {
      cov_24axaiejip.b[9][1]++;
    }
    cov_24axaiejip.s[44]++;
    if (!item) {
      cov_24axaiejip.b[11][0]++;
      cov_24axaiejip.s[45]++;

      item = $scope.dashboard.item;
    } else {
        cov_24axaiejip.b[11][1]++;
        cov_24axaiejip.s[46]++;
        if (!$scope.dashboard.item) {
          cov_24axaiejip.b[12][0]++;
          cov_24axaiejip.s[47]++;

          $scope.dashboard.item = item;
        } else {
          cov_24axaiejip.b[12][1]++;
        }
      }cov_24axaiejip.s[48]++;
    if ($scope.listData_unites_bksb.length == 0) {
      cov_24axaiejip.b[13][0]++;
      cov_24axaiejip.s[49]++;

      return;
    } else {
      cov_24axaiejip.b[13][1]++;
    }

    cov_24axaiejip.s[50]++;
    if ($scope.listData_GeoLevels_bksb.length == 0) {
      cov_24axaiejip.b[14][0]++;
      cov_24axaiejip.s[51]++;

      return;
    } else {
      cov_24axaiejip.b[14][1]++;
    }

    cov_24axaiejip.s[52]++;
    if ($scope.listData_TypeIndicateur_bksb.length == 0) {
      cov_24axaiejip.b[15][0]++;
      cov_24axaiejip.s[53]++;

      return;
    } else {
      cov_24axaiejip.b[15][1]++;
    }

    cov_24axaiejip.s[54]++;
    $scope.isOpen = true;

    cov_24axaiejip.s[55]++;
    $scope.selectedItemUnit = null;
    cov_24axaiejip.s[56]++;
    for (var _iterator = $scope.listData_unites_bksb, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var el = _ref;
      cov_24axaiejip.s[57]++;

      if (el.id == item.ID_UNITE) {
        cov_24axaiejip.b[16][0]++;
        cov_24axaiejip.s[58]++;

        $scope.selectedItemUnit = el;
        cov_24axaiejip.s[59]++;
        break;
      } else {
        cov_24axaiejip.b[16][1]++;
      }
    }
    cov_24axaiejip.s[60]++;
    if (item.TYPE_UNITES == 3) {
      cov_24axaiejip.b[17][0]++;
      cov_24axaiejip.s[61]++;

      $CRUDService.getAll(PATHVP, { get: 'all', indic: item.id }, function (data) {
        cov_24axaiejip.f[5]++;
        cov_24axaiejip.s[62]++;

        for (var i = data.length - 1; i >= 0; i--) {
          cov_24axaiejip.s[63]++;

          data[i].hideEditor = true;
          cov_24axaiejip.s[64]++;
          data[i].Ponderation = eval(data[i].Ponderation);
        }
        cov_24axaiejip.s[65]++;
        $scope.listValeurPossible = data;
      });
    } else {
      cov_24axaiejip.b[17][1]++;
    }
    cov_24axaiejip.s[66]++;
    $scope.dashboard.listLevelGeo = [];
    cov_24axaiejip.s[67]++;
    for (var _iterator2 = $scope.listData_GeoLevels_bksb, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var _el = _ref2;
      cov_24axaiejip.s[68]++;

      if ((cov_24axaiejip.b[19][0]++, _el.id == item.CODE_NG) || (cov_24axaiejip.b[19][1]++, _el.id <= item.CODE_NG) && (cov_24axaiejip.b[19][2]++, item.TYPE_UNITES < 3)) {
        cov_24axaiejip.b[18][0]++;
        cov_24axaiejip.s[69]++;

        $scope.dashboard.listLevelGeo.push(_el);
      } else {
        cov_24axaiejip.b[18][1]++;
      }
    }
    cov_24axaiejip.s[70]++;
    $scope.dashboard.listYear = [].concat($deltadate.getYearBetween(item.DEB_EVAL_INDIC, item.FIN_EVAL_INDIC));
    cov_24axaiejip.s[71]++;
    $scope.getGlobalValue(item);
    cov_24axaiejip.s[72]++;
    $scope.dashboard.NG = $scope.dashboard.listLevelGeo[0];
    cov_24axaiejip.s[73]++;
    $scope.dashboard.yearSuivi = $scope.dashboard.listYear[0];

    cov_24axaiejip.s[74]++;
    $scope.dashboard.yearFollow = $scope.dashboard.listYear[0];

    cov_24axaiejip.s[75]++;
    $scope.dashboard.listSuivi = [];
    cov_24axaiejip.s[76]++;
    $scope.dashboard.listFollow = [];
    cov_24axaiejip.s[77]++;
    if (item.PERIOD_INDIC == 1) {
      cov_24axaiejip.b[20][0]++;
      cov_24axaiejip.s[78]++;

      $scope.dashboard.display_period = false;
      cov_24axaiejip.s[79]++;
      $scope.locationDashboard.typeGraph = 1;
    } else {
      cov_24axaiejip.b[20][1]++;
    }
    cov_24axaiejip.s[80]++;
    $scope.lastGrapeParams = { item: null, index: null };
    cov_24axaiejip.s[81]++;
    $scope.mapDisplay.displayCity = false;
    cov_24axaiejip.s[82]++;
    $scope.mapDisplay.displaySatelite = false;
  };
  cov_24axaiejip.s[83]++;
  $scope.selectYearSuivi = function () {
    cov_24axaiejip.f[6]++;
    cov_24axaiejip.s[84]++;

    if ($scope.lastGrapeParams.index == 2) {
      cov_24axaiejip.b[21][0]++;
      cov_24axaiejip.s[85]++;

      $scope.lastGrapeParams = { item: null, index: null };
    } else {
      cov_24axaiejip.b[21][1]++;
    }
    var year = (cov_24axaiejip.s[86]++, $scope.dashboard.yearSuivi.id);
    cov_24axaiejip.s[87]++;
    $scope.dashboard.listPeriodSuivi = $deltadate.getYearPeriod(year, $scope.dashboard.item.PERIOD_INDIC);
    cov_24axaiejip.s[88]++;
    $scope.dashboard.periodSuivi = $scope.dashboard.listPeriodSuivi[0];
    cov_24axaiejip.s[89]++;
    $scope.dashboard.listSuiviPeriod = [];
    cov_24axaiejip.s[90]++;
    $scope.mapDisplay.getYear();
  };
  cov_24axaiejip.s[91]++;
  $scope.selectPeriodSuivi = function () {
    cov_24axaiejip.f[7]++;
    cov_24axaiejip.s[92]++;

    if ($scope.mapDisplay.period_type == 3) {
      cov_24axaiejip.b[22][0]++;
      cov_24axaiejip.s[93]++;

      $scope.mapDisplay.displayOnGraphe();
    } else {
      cov_24axaiejip.b[22][1]++;
    }
  };
  cov_24axaiejip.s[94]++;
  $scope.mapDisplay = {
    firstSpatial: {
      getGlobal: function getGlobal() {
        cov_24axaiejip.s[95]++;

        $scope.mapDisplay.listData = null;
        cov_24axaiejip.s[96]++;
        if (this.layerGroup) {
          cov_24axaiejip.b[23][0]++;
          cov_24axaiejip.s[97]++;

          this.layerGroup.clearLayers();
          cov_24axaiejip.s[98]++;
          this.layerGroup = null;
        } else {
          cov_24axaiejip.b[23][1]++;
        }

        cov_24axaiejip.s[99]++;
        this.layerGroup = L.layerGroup([]);
        cov_24axaiejip.s[100]++;
        this.layerGroup.addTo($scope.mapDisplay.mymap);
        cov_24axaiejip.s[101]++;
        $CRUDService.getAll(PATHINDIC, {
          get: 'suivi_n_g',
          ID_INDIC: $scope.dashboard.item.id,
          CODE_NG: $scope.dashboard.item.CODE_NG,
          CODE_CL: $scope.dashboard.item.CODE_CL
        }, function (data) {
          cov_24axaiejip.f[8]++;
          cov_24axaiejip.s[102]++;

          for (var _iterator3 = data, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
            var _ref3;

            if (_isArray3) {
              if (_i3 >= _iterator3.length) break;
              _ref3 = _iterator3[_i3++];
            } else {
              _i3 = _iterator3.next();
              if (_i3.done) break;
              _ref3 = _i3.value;
            }

            var el = _ref3;
            cov_24axaiejip.s[103]++;

            el.vp = eval(el.vp);
            cov_24axaiejip.s[104]++;
            el.vr = eval(el.vr);
            cov_24axaiejip.s[105]++;
            el.cp = eval(el.cp);
            cov_24axaiejip.s[106]++;
            el.cr = eval(el.cr);
            cov_24axaiejip.s[107]++;
            for (var _iterator4 = el.ye, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
              var _ref4;

              if (_isArray4) {
                if (_i4 >= _iterator4.length) break;
                _ref4 = _iterator4[_i4++];
              } else {
                _i4 = _iterator4.next();
                if (_i4.done) break;
                _ref4 = _i4.value;
              }

              var ele = _ref4;
              cov_24axaiejip.s[108]++;

              ele.vp = eval(ele.vp);
              cov_24axaiejip.s[109]++;
              ele.vr = eval(ele.vr);
              cov_24axaiejip.s[110]++;
              ele.cp = eval(ele.cp);
              cov_24axaiejip.s[111]++;
              ele.cr = eval(ele.cr);
            }
          }
          cov_24axaiejip.s[112]++;
          $scope.mapDisplay.listData = data;
          cov_24axaiejip.s[113]++;
          $scope.mapDisplay.firstSpatial.getYear();
        });
      },
      getYear: function getYear() {
        cov_24axaiejip.s[114]++;

        if (!$scope.mapDisplay.listData) {
          cov_24axaiejip.b[24][0]++;
          cov_24axaiejip.s[115]++;

          return;
        } else {
          cov_24axaiejip.b[24][1]++;
        }
        var year = (cov_24axaiejip.s[116]++, $scope.dashboard.yearSuivi.id);
        cov_24axaiejip.s[117]++;
        if (localStorage.getItem(KEY_YEAR_BASE) != year) {
          cov_24axaiejip.b[25][0]++;
          cov_24axaiejip.s[118]++;

          $scope.dashboard.periodSuivi = $scope.dashboard.listPeriodSuivi[0];
        } else {
          cov_24axaiejip.b[25][1]++;
          cov_24axaiejip.s[119]++;

          for (var _iterator5 = $scope.dashboard.listPeriodSuivi, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
            var _ref5;

            if (_isArray5) {
              if (_i5 >= _iterator5.length) break;
              _ref5 = _iterator5[_i5++];
            } else {
              _i5 = _iterator5.next();
              if (_i5.done) break;
              _ref5 = _i5.value;
            }

            var per = _ref5;
            cov_24axaiejip.s[120]++;

            if (per.index == localStorage.getItem(KEY_PERIOD_BASE)) {
              cov_24axaiejip.b[26][0]++;
              cov_24axaiejip.s[121]++;

              $scope.dashboard.periodSuivi = per;
              cov_24axaiejip.s[122]++;
              break;
            } else {
              cov_24axaiejip.b[26][1]++;
            }
          }
        }

        cov_24axaiejip.s[123]++;
        $CRUDService.getAll(PATHINDIC, {
          get: 'suivi_n_p',
          ID_INDIC: $scope.dashboard.item.id,
          CODE_NG: $scope.dashboard.item.CODE_NG,
          CODE_CL: $scope.dashboard.item.CODE_CL,
          annee: $scope.dashboard.yearSuivi ? (cov_24axaiejip.b[27][0]++, $scope.dashboard.yearSuivi.id) : (cov_24axaiejip.b[27][1]++, 0)
        }, function (data) {
          cov_24axaiejip.f[9]++;
          cov_24axaiejip.s[124]++;

          for (var _iterator6 = data, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
            var _ref6;

            if (_isArray6) {
              if (_i6 >= _iterator6.length) break;
              _ref6 = _iterator6[_i6++];
            } else {
              _i6 = _iterator6.next();
              if (_i6.done) break;
              _ref6 = _i6.value;
            }

            var el = _ref6;
            cov_24axaiejip.s[125]++;

            for (var _iterator8 = el.d, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
              var _ref8;

              if (_isArray8) {
                if (_i8 >= _iterator8.length) break;
                _ref8 = _iterator8[_i8++];
              } else {
                _i8 = _iterator8.next();
                if (_i8.done) break;
                _ref8 = _i8.value;
              }

              var ele = _ref8;
              cov_24axaiejip.s[126]++;

              ele.vp = eval(ele.vp);
              cov_24axaiejip.s[127]++;
              ele.vr = eval(ele.vr);
              cov_24axaiejip.s[128]++;
              ele.cp = eval(ele.cp);
              cov_24axaiejip.s[129]++;
              ele.cr = eval(ele.cr);
            }
          }
          cov_24axaiejip.s[130]++;
          for (var _iterator7 = $scope.mapDisplay.listData, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
            var _ref7;

            if (_isArray7) {
              if (_i7 >= _iterator7.length) break;
              _ref7 = _iterator7[_i7++];
            } else {
              _i7 = _iterator7.next();
              if (_i7.done) break;
              _ref7 = _i7.value;
            }

            var _el2 = _ref7;
            cov_24axaiejip.s[131]++;

            _el2.per = [];
            cov_24axaiejip.s[132]++;
            for (var _iterator9 = data, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
              var _ref9;

              if (_isArray9) {
                if (_i9 >= _iterator9.length) break;
                _ref9 = _iterator9[_i9++];
              } else {
                _i9 = _iterator9.next();
                if (_i9.done) break;
                _ref9 = _i9.value;
              }

              var _ele = _ref9;
              cov_24axaiejip.s[133]++;

              if (_el2.id == _ele.id) {
                cov_24axaiejip.b[28][0]++;
                cov_24axaiejip.s[134]++;

                _el2.per = _ele.d;
                cov_24axaiejip.s[135]++;
                break;
              } else {
                cov_24axaiejip.b[28][1]++;
              }
            }
          }
          cov_24axaiejip.s[136]++;
          $scope.mapDisplay.firstSpatial.displayOnGraphe();
        });
      },
      __getGlobalData: function __getGlobalData() {
        var max_Data = (cov_24axaiejip.s[137]++, 0);
        var min_Data = (cov_24axaiejip.s[138]++, 999999999);
        var data = (cov_24axaiejip.s[139]++, []);
        cov_24axaiejip.s[140]++;
        for (var _iterator10 = $scope.mapDisplay.listData, _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _iterator10[Symbol.iterator]();;) {
          var _ref10;

          if (_isArray10) {
            if (_i10 >= _iterator10.length) break;
            _ref10 = _iterator10[_i10++];
          } else {
            _i10 = _iterator10.next();
            if (_i10.done) break;
            _ref10 = _i10.value;
          }

          var el = _ref10;
          cov_24axaiejip.s[141]++;

          if (!el.vr) {
            cov_24axaiejip.b[29][0]++;
            cov_24axaiejip.s[142]++;

            continue;
          } else {
            cov_24axaiejip.b[29][1]++;
          }
          cov_24axaiejip.s[143]++;
          if (max_Data <= el.vr) {
            cov_24axaiejip.b[30][0]++;
            cov_24axaiejip.s[144]++;

            max_Data = el.vr;
          } else {
            cov_24axaiejip.b[30][1]++;
          }
          cov_24axaiejip.s[145]++;
          if (min_Data >= el.vr) {
            cov_24axaiejip.b[31][0]++;
            cov_24axaiejip.s[146]++;

            min_Data = el.vr;
          } else {
            cov_24axaiejip.b[31][1]++;
          }
          cov_24axaiejip.s[147]++;
          data.push({ c: el.c.toUpperCase(), v: el.vr });
        }
        cov_24axaiejip.s[148]++;
        return { min: min_Data, max: max_Data, data: data };
      },
      __getAnnuelData: function __getAnnuelData() {
        var max_Data = (cov_24axaiejip.s[149]++, 0);
        var min_Data = (cov_24axaiejip.s[150]++, 999999999);
        var data = (cov_24axaiejip.s[151]++, []);
        cov_24axaiejip.s[152]++;
        for (var _iterator11 = $scope.mapDisplay.listData, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _iterator11[Symbol.iterator]();;) {
          var _ref11;

          if (_isArray11) {
            if (_i11 >= _iterator11.length) break;
            _ref11 = _iterator11[_i11++];
          } else {
            _i11 = _iterator11.next();
            if (_i11.done) break;
            _ref11 = _i11.value;
          }

          var elt = _ref11;
          cov_24axaiejip.s[153]++;

          for (var _iterator12 = elt.ye, _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _iterator12[Symbol.iterator]();;) {
            var _ref12;

            if (_isArray12) {
              if (_i12 >= _iterator12.length) break;
              _ref12 = _iterator12[_i12++];
            } else {
              _i12 = _iterator12.next();
              if (_i12.done) break;
              _ref12 = _i12.value;
            }

            var el = _ref12;
            cov_24axaiejip.s[154]++;

            if (el.y != $scope.dashboard.yearSuivi.id) {
              cov_24axaiejip.b[32][0]++;
              cov_24axaiejip.s[155]++;

              continue;
            } else {
              cov_24axaiejip.b[32][1]++;
            }
            cov_24axaiejip.s[156]++;
            if (!el.vr) {
              cov_24axaiejip.b[33][0]++;
              cov_24axaiejip.s[157]++;

              continue;
            } else {
              cov_24axaiejip.b[33][1]++;
            }
            cov_24axaiejip.s[158]++;
            if (max_Data <= el.vr) {
              cov_24axaiejip.b[34][0]++;
              cov_24axaiejip.s[159]++;

              max_Data = el.vr;
            } else {
              cov_24axaiejip.b[34][1]++;
            }
            cov_24axaiejip.s[160]++;
            if (min_Data >= el.vr) {
              cov_24axaiejip.b[35][0]++;
              cov_24axaiejip.s[161]++;

              min_Data = el.vr;
            } else {
              cov_24axaiejip.b[35][1]++;
            }
            cov_24axaiejip.s[162]++;
            data.push({ c: elt.c.toUpperCase(), v: el.vr });
          }
        }
        cov_24axaiejip.s[163]++;
        return { min: min_Data, max: max_Data, data: data };
      },
      __getPeriodData: function __getPeriodData() {
        var max_Data = (cov_24axaiejip.s[164]++, 0);
        var min_Data = (cov_24axaiejip.s[165]++, 999999999);
        var data = (cov_24axaiejip.s[166]++, []);
        cov_24axaiejip.s[167]++;
        for (var _iterator13 = $scope.mapDisplay.listData, _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _iterator13[Symbol.iterator]();;) {
          var _ref13;

          if (_isArray13) {
            if (_i13 >= _iterator13.length) break;
            _ref13 = _iterator13[_i13++];
          } else {
            _i13 = _iterator13.next();
            if (_i13.done) break;
            _ref13 = _i13.value;
          }

          var elt = _ref13;
          cov_24axaiejip.s[168]++;

          for (var _iterator14 = elt.per, _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : _iterator14[Symbol.iterator]();;) {
            var _ref14;

            if (_isArray14) {
              if (_i14 >= _iterator14.length) break;
              _ref14 = _iterator14[_i14++];
            } else {
              _i14 = _iterator14.next();
              if (_i14.done) break;
              _ref14 = _i14.value;
            }

            var el = _ref14;
            cov_24axaiejip.s[169]++;

            if (el.n != $scope.dashboard.periodSuivi.index) {
              cov_24axaiejip.b[36][0]++;
              cov_24axaiejip.s[170]++;

              continue;
            } else {
              cov_24axaiejip.b[36][1]++;
            }
            cov_24axaiejip.s[171]++;
            if (!el.vr) {
              cov_24axaiejip.b[37][0]++;
              cov_24axaiejip.s[172]++;

              continue;
            } else {
              cov_24axaiejip.b[37][1]++;
            }
            cov_24axaiejip.s[173]++;
            if (max_Data <= el.vr) {
              cov_24axaiejip.b[38][0]++;
              cov_24axaiejip.s[174]++;

              max_Data = el.vr;
            } else {
              cov_24axaiejip.b[38][1]++;
            }
            cov_24axaiejip.s[175]++;
            if (min_Data >= el.vr) {
              cov_24axaiejip.b[39][0]++;
              cov_24axaiejip.s[176]++;

              min_Data = el.vr;
            } else {
              cov_24axaiejip.b[39][1]++;
            }
            cov_24axaiejip.s[177]++;
            data.push({ c: elt.c.toUpperCase(), v: el.vr });
          }
        }
        cov_24axaiejip.s[178]++;
        return { min: min_Data, max: max_Data, data: data };
      },
      displayOnGraphe: function displayOnGraphe() {
        var data = (cov_24axaiejip.s[179]++, {});
        cov_24axaiejip.s[180]++;
        switch ($scope.mapDisplay.period_type) {
          case 1:
            cov_24axaiejip.b[40][0]++;
          case '1':
            cov_24axaiejip.b[40][1]++;
            cov_24axaiejip.s[181]++;

            data = this.__getGlobalData();
            cov_24axaiejip.s[182]++;
            break;
          case 2:
            cov_24axaiejip.b[40][2]++;
          case '2':
            cov_24axaiejip.b[40][3]++;
            cov_24axaiejip.s[183]++;

            data = this.__getAnnuelData();
            cov_24axaiejip.s[184]++;
            break;
          case 3:
            cov_24axaiejip.b[40][4]++;
          case '3':
            cov_24axaiejip.b[40][5]++;
            cov_24axaiejip.s[185]++;

            data = this.__getPeriodData();
            cov_24axaiejip.s[186]++;
            break;
          default:
            cov_24axaiejip.b[40][6]++;

        }
        cov_24axaiejip.s[187]++;
        this.layerGroup.clearLayers();
        cov_24axaiejip.s[188]++;
        for (var _iterator15 = data.data, _isArray15 = Array.isArray(_iterator15), _i15 = 0, _iterator15 = _isArray15 ? _iterator15 : _iterator15[Symbol.iterator]();;) {
          var _ref15;

          if (_isArray15) {
            if (_i15 >= _iterator15.length) break;
            _ref15 = _iterator15[_i15++];
          } else {
            _i15 = _iterator15.next();
            if (_i15.done) break;
            _ref15 = _i15.value;
          }

          var el = _ref15;

          var valu = (cov_24axaiejip.s[189]++, (cov_24axaiejip.b[41][0]++, el.v) || (cov_24axaiejip.b[41][1]++, 0));
          var a = (cov_24axaiejip.s[190]++, 0);
          var b = (cov_24axaiejip.s[191]++, 0);
          var loc = (cov_24axaiejip.s[192]++, '');
          cov_24axaiejip.s[193]++;
          for (var _iterator16 = listCountry, _isArray16 = Array.isArray(_iterator16), _i16 = 0, _iterator16 = _isArray16 ? _iterator16 : _iterator16[Symbol.iterator]();;) {
            var _ref16;

            if (_isArray16) {
              if (_i16 >= _iterator16.length) break;
              _ref16 = _iterator16[_i16++];
            } else {
              _i16 = _iterator16.next();
              if (_i16.done) break;
              _ref16 = _i16.value;
            }

            var countr = _ref16;
            cov_24axaiejip.s[194]++;

            if ((cov_24axaiejip.b[43][0]++, countr.nameen.toUpperCase() == el.c.toUpperCase()) || (cov_24axaiejip.b[43][1]++, countr.namefr.toUpperCase() == el.c.toUpperCase())) {
              cov_24axaiejip.b[42][0]++;
              cov_24axaiejip.s[195]++;

              a = countr.long;
              cov_24axaiejip.s[196]++;
              b = countr.lat;
              cov_24axaiejip.s[197]++;
              loc = countr.nameen.toUpperCase();
              cov_24axaiejip.s[198]++;
              break;
            } else {
              cov_24axaiejip.b[42][1]++;
            }
          }
          cov_24axaiejip.s[199]++;
          if ((cov_24axaiejip.b[45][0]++, a === 0) && (cov_24axaiejip.b[45][1]++, b === 0)) {
            cov_24axaiejip.b[44][0]++;
            cov_24axaiejip.s[200]++;

            continue;
          } else {
            cov_24axaiejip.b[44][1]++;
          }
          var geojsonMarkerOption = (cov_24axaiejip.s[201]++, {
            radius: data.min == data.max ? (cov_24axaiejip.b[46][0]++, 100000) : (cov_24axaiejip.b[46][1]++, 50000 + 300000 * (valu - data.min) / (data.max - data.min)),
            fillColor: '#dd4b39',
            color: '#dd4b39',
            weight: 1,
            opacity: 1,
            fillOpacity: 0.5
          });

          var circle = (cov_24axaiejip.s[202]++, L.circle(new L.LatLng(b, a), geojsonMarkerOption));
          var straff = (cov_24axaiejip.s[203]++, '<div>' + '<h4>' + loc + '</h4>' + '<div class=\'display-flex\'><div class=" m-r-xs" style=\'font-weight: bold;\'>' + $translate.instant('INDICATOR.VALUE') + ' ' + $scope.dashboard.item.CODE_INDIC + ' : </div>' + '<div > ' + ((cov_24axaiejip.b[47][0]++, el.v) || (cov_24axaiejip.b[47][1]++, 0)) + ' <span style=\'small\'>' + $scope.selectedItemUnit.CODE_UNITE + '</span>' + '</div></div>' + '</div>');
          cov_24axaiejip.s[204]++;
          circle.bindPopup(straff);
          cov_24axaiejip.s[205]++;
          circle.bindTooltip(straff);

          cov_24axaiejip.s[206]++;
          circle.addTo(this.layerGroup);
        }
      }
    },
    secondSpatial: {
      processGeoJson: function processGeoJson(urlparam) {
        var defaultParameters = (cov_24axaiejip.s[207]++, {
          service: 'WFS',
          version: '1.0.0',
          request: 'getFeature',
          typeName: 'cite:bc_well_data_wgs',
          maxFeatures: 3000,
          outputFormat: 'application/json'
        });
        var url = (cov_24axaiejip.s[208]++, ((cov_24axaiejip.b[48][0]++, urlparam) || (cov_24axaiejip.b[48][1]++, '')).split('?'));
        cov_24axaiejip.s[209]++;
        url[1] = ((cov_24axaiejip.b[49][0]++, url[1]) || (cov_24axaiejip.b[49][1]++, '')).split('&');
        cov_24axaiejip.s[210]++;
        for (var _iterator17 = url[1], _isArray17 = Array.isArray(_iterator17), _i17 = 0, _iterator17 = _isArray17 ? _iterator17 : _iterator17[Symbol.iterator]();;) {
          var _ref17;

          if (_isArray17) {
            if (_i17 >= _iterator17.length) break;
            _ref17 = _iterator17[_i17++];
          } else {
            _i17 = _iterator17.next();
            if (_i17.done) break;
            _ref17 = _i17.value;
          }

          var param = _ref17;

          var key = (cov_24axaiejip.s[211]++, param.split('='));
          cov_24axaiejip.s[212]++;
          defaultParameters[((cov_24axaiejip.b[50][0]++, key[0]) || (cov_24axaiejip.b[50][1]++, '')).trim()] = ((cov_24axaiejip.b[51][0]++, key[1]) || (cov_24axaiejip.b[51][1]++, '')).trim();
        }

        cov_24axaiejip.s[213]++;

        $http({
          method: 'GET',
          url: url[0],
          params: defaultParameters
        }).then(function (response) {
          cov_24axaiejip.f[10]++;

          var data = (cov_24axaiejip.s[214]++, response.data);
        }, function () {
          cov_24axaiejip.f[11]++;
        });
      },
      selectPeriod: function selectPeriod() {
        cov_24axaiejip.s[215]++;

        $CRUDService.getAll('MapLayer', {
          get: 'all__',
          id_indic: $scope.dashboard.item.id,
          y: $scope.dashboard.yearSuivi.id,
          p: $scope.dashboard.periodSuivi.index
        }, function (data) {
          cov_24axaiejip.f[12]++;
          cov_24axaiejip.s[216]++;

          var _loop = function _loop() {
            if (_isArray18) {
              if (_i18 >= _iterator18.length) return 'break';
              _ref18 = _iterator18[_i18++];
            } else {
              _i18 = _iterator18.next();
              if (_i18.done) return 'break';
              _ref18 = _i18.value;
            }

            var item = _ref18;
            cov_24axaiejip.s[217]++;

            if (!item.options.dyn) {
              cov_24axaiejip.b[52][0]++;
              cov_24axaiejip.s[218]++;

              return 'continue';
            } else {
              cov_24axaiejip.b[52][1]++;
            }
            var url = (cov_24axaiejip.s[219]++, '');
            cov_24axaiejip.s[220]++;
            for (var _iterator19 = data, _isArray19 = Array.isArray(_iterator19), _i19 = 0, _iterator19 = _isArray19 ? _iterator19 : _iterator19[Symbol.iterator]();;) {
              var _ref19;

              if (_isArray19) {
                if (_i19 >= _iterator19.length) break;
                _ref19 = _iterator19[_i19++];
              } else {
                _i19 = _iterator19.next();
                if (_i19.done) break;
                _ref19 = _i19.value;
              }

              var myurl = _ref19;
              cov_24axaiejip.s[221]++;

              if (myurl.id == item.options.id_) {
                cov_24axaiejip.b[53][0]++;
                cov_24axaiejip.s[222]++;

                url = myurl.url;
                cov_24axaiejip.s[223]++;
                break;
              } else {
                cov_24axaiejip.b[53][1]++;
              }
            }
            cov_24axaiejip.s[224]++;
            item.options.url_ = url;
            var param = (cov_24axaiejip.s[225]++, $scope.mapDisplay.processRequest(url, item.options.geo));
            cov_24axaiejip.s[226]++;
            if (item.options.geo) {
              cov_24axaiejip.b[54][0]++;
              cov_24axaiejip.s[227]++;

              item.clearLayers();
              cov_24axaiejip.s[228]++;
              if (param[0] == '') {
                cov_24axaiejip.b[55][0]++;
                cov_24axaiejip.s[229]++;

                return {
                  v: void 0
                };
              } else {
                cov_24axaiejip.b[55][1]++;
              }
              var urlparam = (cov_24axaiejip.s[230]++, param[0] + '?u=1');
              cov_24axaiejip.s[231]++;
              for (var elparam in param[1]) {
                cov_24axaiejip.s[232]++;

                urlparam += '&' + elparam + '=' + param[1][elparam];
              }
              cov_24axaiejip.s[233]++;
              item.options.loading = true;
              cov_24axaiejip.s[234]++;
              $CRUDService.getAll('MapLayer', {
                get: 'all__geojson',
                url_: urlparam,
                idl: item.options.id_
              }, function (url_resp) {
                cov_24axaiejip.f[13]++;
                cov_24axaiejip.s[235]++;

                L.geoJson.ajax($deltahttp.get_data_folder() + url_resp, {
                  middleware: function middleware(data) {
                    cov_24axaiejip.s[236]++;

                    $scope.$apply(function () {
                      cov_24axaiejip.f[14]++;
                      cov_24axaiejip.s[237]++;

                      item.options.loading = false;
                      cov_24axaiejip.s[238]++;
                      item.addData(data);
                      cov_24axaiejip.s[239]++;
                      item._oldData = data;
                      cov_24axaiejip.s[240]++;
                      for (var _iterator20 = item.getLayers(), _isArray20 = Array.isArray(_iterator20), _i20 = 0, _iterator20 = _isArray20 ? _iterator20 : _iterator20[Symbol.iterator]();;) {
                        var _ref20;

                        if (_isArray20) {
                          if (_i20 >= _iterator20.length) break;
                          _ref20 = _iterator20[_i20++];
                        } else {
                          _i20 = _iterator20.next();
                          if (_i20.done) break;
                          _ref20 = _i20.value;
                        }

                        var layer = _ref20;
                        cov_24axaiejip.s[241]++;

                        $scope.mapDisplay.secondSpatial.geolayerClick(layer, item.options.PROPERTY);
                      }
                    });
                  }
                });
              });
              cov_24axaiejip.s[242]++;
              return {
                v: void 0
              };
            } else {
              cov_24axaiejip.b[54][1]++;
            }
            cov_24axaiejip.s[243]++;
            item.setUrl(param[0], true);
            cov_24axaiejip.s[244]++;
            item.setParams(param[1], false);
          };

          _loop2: for (var _iterator18 = $scope.mapDisplay.layerGroup.getLayers(), _isArray18 = Array.isArray(_iterator18), _i18 = 0, _iterator18 = _isArray18 ? _iterator18 : _iterator18[Symbol.iterator]();;) {
            var _ref18;

            var _ret = _loop();

            switch (_ret) {
              case 'break':
                break _loop2;

              case 'continue':
                continue;

              default:
                if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
            }
          }
        });
      },
      geolayerClick: function geolayerClick(layer, mask_item) {
        cov_24axaiejip.s[245]++;

        layer.on('click', function (a, b, c, d) {
          cov_24axaiejip.f[15]++;

          var property = (cov_24axaiejip.s[246]++, a.target.feature.properties);
          var mask = (cov_24axaiejip.s[247]++, (cov_24axaiejip.b[56][0]++, mask_item) || (cov_24axaiejip.b[56][1]++, ''));
          cov_24axaiejip.s[248]++;
          for (var prop in property) {
            cov_24axaiejip.s[249]++;

            while (true) {
              var oldmask = (cov_24axaiejip.s[250]++, mask);
              var value = (cov_24axaiejip.s[251]++, property[prop]);
              cov_24axaiejip.s[252]++;
              if (angular.isNumber(value)) {
                cov_24axaiejip.b[57][0]++;
                cov_24axaiejip.s[253]++;

                value = $filter('number')(value);
              } else {
                cov_24axaiejip.b[57][1]++;
              }
              cov_24axaiejip.s[254]++;
              mask = mask.replace('{' + prop + '}', value);
              cov_24axaiejip.s[255]++;
              if (oldmask == mask) {
                cov_24axaiejip.b[58][0]++;
                cov_24axaiejip.s[256]++;

                break;
              } else {
                cov_24axaiejip.b[58][1]++;
              }
            }
          }
          cov_24axaiejip.s[257]++;
          L.popup().setLatLng(a.latlng).setContent(mask).openOn($scope.mapDisplay.mymap);
        });
      },
      selectYear: function selectYear() {
        var year = (cov_24axaiejip.s[258]++, $scope.dashboard.yearSuivi.id);
        cov_24axaiejip.s[259]++;
        $scope.dashboard.listPeriodSuivi = $deltadate.getYearPeriod(year, $scope.dashboard.item.PERIOD_INDIC);
        cov_24axaiejip.s[260]++;
        $scope.dashboard.periodSuivi = $scope.dashboard.listPeriodSuivi[0];
        cov_24axaiejip.s[261]++;
        this.selectPeriod();
      },
      validate: function validate(fn) {
        cov_24axaiejip.s[262]++;

        $CRUDService.save('MapLayer', {
          action: 'MiseAJour_item',
          valeur: $filter('json')(this.listinfo), id_indic: $scope.dashboard.item.id,
          y: $scope.dashboard.yearSuivi.id,
          p: $scope.dashboard.periodSuivi.index
        }, function (data) {
          cov_24axaiejip.f[16]++;
          cov_24axaiejip.s[263]++;

          $scope.mapDisplay.secondSpatial.selectPeriod();
          cov_24axaiejip.s[264]++;

          if (fn) {
            cov_24axaiejip.b[59][0]++;
            cov_24axaiejip.s[265]++;

            fn();
          } else {
            cov_24axaiejip.b[59][1]++;
          }
        });
        cov_24axaiejip.s[266]++;
        return true;
      },
      editURL: function editURL() {
        cov_24axaiejip.s[267]++;

        this.listinfo = [];
        cov_24axaiejip.s[268]++;
        for (var _iterator21 = $scope.mapDisplay.layerGroup.getLayers(), _isArray21 = Array.isArray(_iterator21), _i21 = 0, _iterator21 = _isArray21 ? _iterator21 : _iterator21[Symbol.iterator]();;) {
          var _ref21;

          if (_isArray21) {
            if (_i21 >= _iterator21.length) break;
            _ref21 = _iterator21[_i21++];
          } else {
            _i21 = _iterator21.next();
            if (_i21.done) break;
            _ref21 = _i21.value;
          }

          var _item = _ref21;
          cov_24axaiejip.s[269]++;

          if (!_item.options.dyn) {
            cov_24axaiejip.b[60][0]++;
            cov_24axaiejip.s[270]++;

            continue;
          } else {
            cov_24axaiejip.b[60][1]++;
          }
          cov_24axaiejip.s[271]++;
          this.listinfo.push({
            url: _item.options.url_,
            id: _item.options.id_,
            label: _item.options.label,
            h: _item._leaflet_id
          });
        }
        cov_24axaiejip.s[272]++;
        $uibModal.open({
          templateUrl: 'app/indicator/dashboard/spatialEdit.html',
          controller: URLCtrl_edit,
          scope: $scope,
          size: 'md',
          backdrop: 'static',
          windowClass: 'animated fadeInRight left-modal'
        });
      }
    },
    getMapUrl: function getMapUrl() {
      var mapstr = (cov_24axaiejip.s[273]++, '');
      var value = (cov_24axaiejip.s[274]++, (this.displayCity ? (cov_24axaiejip.b[61][0]++, 1) : (cov_24axaiejip.b[61][1]++, 0)) + (this.displaySatelite ? (cov_24axaiejip.b[62][0]++, 2) : (cov_24axaiejip.b[62][1]++, 0)));
      cov_24axaiejip.s[275]++;
      switch (value) {
        case 0:
          cov_24axaiejip.b[63][0]++;
          cov_24axaiejip.s[276]++;

          mapstr = 'https://api.mapbox.com/styles/v1/bksb/cj8x1v3iv05pz2rrtc9ps1tui/tiles/256/{z}/{x}/{y}';
          cov_24axaiejip.s[277]++;
          break;
        case 1:
          cov_24axaiejip.b[63][1]++;
          cov_24axaiejip.s[278]++;

          mapstr = 'https://api.mapbox.com/styles/v1/bksb/cj95jexfc1b622rnuab1dwxjy/tiles/256/{z}/{x}/{y}';
          cov_24axaiejip.s[279]++;
          break;
        case 2:
          cov_24axaiejip.b[63][2]++;
          cov_24axaiejip.s[280]++;

          mapstr = 'https://api.mapbox.com/styles/v1/bksb/cj8x4hp109ijw2roga73f27b3/tiles/256/{z}/{x}/{y}';
          cov_24axaiejip.s[281]++;
          break;
        case 3:
          cov_24axaiejip.b[63][3]++;
          cov_24axaiejip.s[282]++;

          mapstr = 'https://api.mapbox.com/styles/v1/bksb/cj95hf8sv0x722rpaamgxthou/tiles/256/{z}/{x}/{y}';
          cov_24axaiejip.s[283]++;
          break;
        default:
          cov_24axaiejip.b[63][4]++;
          cov_24axaiejip.s[284]++;

          mapstr = 'https://api.mapbox.com/styles/v1/bksb/cj8x1v3iv05pz2rrtc9ps1tui/tiles/256/{z}/{x}/{y}';
          cov_24axaiejip.s[285]++;
          break;
      }
      cov_24axaiejip.s[286]++;
      return mapstr + '?access_token=pk.eyJ1IjoiYmtzYiIsImEiOiJjaXQ5ZHlpM2gwMDJvMnNwaDAxZXFsbndrIn0.0W3tcj-HtlRSCJDcuxNRew';
    },
    changeBackground: function changeBackground() {
      cov_24axaiejip.s[287]++;

      $scope.mapDisplay.background.setUrl(this.getMapUrl());
    },
    getYear: function getYear(params) {
      cov_24axaiejip.s[288]++;

      if ((cov_24axaiejip.b[65][0]++, $scope.dashboard.item.SPATIAL_) && (cov_24axaiejip.b[65][1]++, !$scope.dashboard.item.SPATIAL________)) {
        cov_24axaiejip.b[64][0]++;
        cov_24axaiejip.s[289]++;

        this.firstSpatial.getYear();
      } else {
        cov_24axaiejip.b[64][1]++;
      }
    },
    getGlobal: function getGlobal(params) {
      cov_24axaiejip.s[290]++;

      if ((cov_24axaiejip.b[67][0]++, $scope.dashboard.item.SPATIAL_) && (cov_24axaiejip.b[67][1]++, !$scope.dashboard.item.SPATIAL________)) {
        cov_24axaiejip.b[66][0]++;
        cov_24axaiejip.s[291]++;

        this.firstSpatial.getGlobal();
      } else {
        cov_24axaiejip.b[66][1]++;
      }
    },
    displayOnGraphe: function displayOnGraphe(params) {
      cov_24axaiejip.s[292]++;

      if ((cov_24axaiejip.b[69][0]++, $scope.dashboard.item.SPATIAL_) && (cov_24axaiejip.b[69][1]++, !$scope.dashboard.item.SPATIAL________)) {
        cov_24axaiejip.b[68][0]++;
        cov_24axaiejip.s[293]++;

        this.firstSpatial.displayOnGraphe();
      } else {
        cov_24axaiejip.b[68][1]++;
      }
    },
    processRequest: function processRequest(urlparam, geo) {
      var result = (cov_24axaiejip.s[294]++, geo ? (cov_24axaiejip.b[70][0]++, {
        service: 'WFS',
        version: '1.0.0',
        request: 'getFeature',
        typeName: '',
        maxFeatures: 50,
        format: 'json',
        outputFormat: 'json',
        jsoncallback: 'json_callback',
        jsonp: false
      }) : (cov_24axaiejip.b[70][1]++, {
        layers: '',
        format: 'image/png',
        transparent: true,
        version: '1.1.0',
        attribution: 'myattribution'
      }));
      var url = (cov_24axaiejip.s[295]++, ((cov_24axaiejip.b[71][0]++, urlparam) || (cov_24axaiejip.b[71][1]++, '')).split('?'));
      cov_24axaiejip.s[296]++;
      url[1] = ((cov_24axaiejip.b[72][0]++, url[1]) || (cov_24axaiejip.b[72][1]++, '')).split('&');
      cov_24axaiejip.s[297]++;
      for (var _iterator22 = url[1], _isArray22 = Array.isArray(_iterator22), _i22 = 0, _iterator22 = _isArray22 ? _iterator22 : _iterator22[Symbol.iterator]();;) {
        var _ref22;

        if (_isArray22) {
          if (_i22 >= _iterator22.length) break;
          _ref22 = _iterator22[_i22++];
        } else {
          _i22 = _iterator22.next();
          if (_i22.done) break;
          _ref22 = _i22.value;
        }

        var _param = _ref22;

        var key = (cov_24axaiejip.s[298]++, _param.split('='));
        cov_24axaiejip.s[299]++;
        if (((cov_24axaiejip.b[74][0]++, key[0]) || (cov_24axaiejip.b[74][1]++, '')).trim() == 'layers') {
          cov_24axaiejip.b[73][0]++;
          cov_24axaiejip.s[300]++;

          result.layers = ((cov_24axaiejip.b[75][0]++, key[1]) || (cov_24axaiejip.b[75][1]++, '')).trim();
          cov_24axaiejip.s[301]++;
          result.typeName = ((cov_24axaiejip.b[76][0]++, key[1]) || (cov_24axaiejip.b[76][1]++, '')).trim();
          cov_24axaiejip.s[302]++;
          break;
        } else {
          cov_24axaiejip.b[73][1]++;
        }
      }
      cov_24axaiejip.s[303]++;
      return [url[0], result];
    },
    getLayers: function getLayers(year, periode) {
      cov_24axaiejip.s[304]++;

      if (!this.layerGroup) {
        cov_24axaiejip.b[77][0]++;
        cov_24axaiejip.s[305]++;

        this.layerGroup = L.layerGroup([], {
          attribution: '© <a href=\'https://www.mapbox.com/about/maps/\'>Mapbox</a> , © <a href=\'https://www.openstreetmap.org/copyright\'>OpenStreetMap</a>  <strong><a href=\'https://www.mapbox.com/map-feedback/\' target=\'_blank\'>Improve this map</a></strong>'
        });
        cov_24axaiejip.s[306]++;
        this.layerGroup.addTo(this.mymap);
      } else {
        cov_24axaiejip.b[77][1]++;
      }
      cov_24axaiejip.s[307]++;
      this.layerGroup.clearLayers();
      cov_24axaiejip.s[308]++;
      $CRUDService.getAll('MapLayer', { get: 'all', id_indic: $scope.dashboard.item.id, y: year, p: periode }, function (data) {
        cov_24axaiejip.f[17]++;
        cov_24axaiejip.s[309]++;

        $scope.mapDisplay.background = L.tileLayer($scope.mapDisplay.getMapUrl()).addTo($scope.mapDisplay.layerGroup);
        cov_24axaiejip.s[310]++;
        for (var _iterator23 = data, _isArray23 = Array.isArray(_iterator23), _i23 = 0, _iterator23 = _isArray23 ? _iterator23 : _iterator23[Symbol.iterator]();;) {
          var _ref23;

          if (_isArray23) {
            if (_i23 >= _iterator23.length) break;
            _ref23 = _iterator23[_i23++];
          } else {
            _i23 = _iterator23.next();
            if (_i23.done) break;
            _ref23 = _i23.value;
          }

          var _item2 = _ref23;

          var res = (cov_24axaiejip.s[311]++, $scope.mapDisplay.processRequest(_item2.URL_));
          cov_24axaiejip.s[312]++;
          if ((cov_24axaiejip.b[79][0]++, _item2.PERIODIC == 0) || (cov_24axaiejip.b[79][1]++, _item2.DATA_LAYER == 0)) {
            cov_24axaiejip.b[78][0]++;

            var layer = (cov_24axaiejip.s[313]++, L.tileLayer.wms(res[0], {
              id_: _item2.id,
              label: _item2.LABEL,
              display__: true,
              dyn: _item2.PERIODIC == 1,
              url_: _item2.URL_
            }).addTo($scope.mapDisplay.layerGroup));
            cov_24axaiejip.s[314]++;
            layer.setParams(res[1]);
          } else {
            cov_24axaiejip.b[78][1]++;

            var _layer = (cov_24axaiejip.s[315]++, L.geoJSON(null, {
              id_: _item2.id,
              url_: _item2.URL_,
              label: _item2.LABEL,
              display__: true,
              dyn: true,
              geo: true,
              PROPERTY: _item2.PROPERTY,
              style: function style(params) {
                cov_24axaiejip.s[316]++;

                return {
                  fillColor: '#ffffff',
                  fillOpacity: 0,
                  color: '#e2ce43'

                };
              }
            }).addTo($scope.mapDisplay.layerGroup));
            cov_24axaiejip.s[317]++;
            _layer.setOpacity = function (p) {
              cov_24axaiejip.f[18]++;
              cov_24axaiejip.s[318]++;

              if (p == 1) {
                cov_24axaiejip.b[80][0]++;
                cov_24axaiejip.s[319]++;

                this.addData((cov_24axaiejip.b[81][0]++, this._oldData) || (cov_24axaiejip.b[81][1]++, null));
                cov_24axaiejip.s[320]++;
                for (var _iterator24 = this.getLayers(), _isArray24 = Array.isArray(_iterator24), _i24 = 0, _iterator24 = _isArray24 ? _iterator24 : _iterator24[Symbol.iterator]();;) {
                  var _ref24;

                  if (_isArray24) {
                    if (_i24 >= _iterator24.length) break;
                    _ref24 = _iterator24[_i24++];
                  } else {
                    _i24 = _iterator24.next();
                    if (_i24.done) break;
                    _ref24 = _i24.value;
                  }

                  var layer_item = _ref24;
                  cov_24axaiejip.s[321]++;

                  $scope.mapDisplay.secondSpatial.geolayerClick(layer_item, this.options.PROPERTY);
                }
              } else {
                cov_24axaiejip.b[80][1]++;
                cov_24axaiejip.s[322]++;

                this.clearLayers();
              }
            };
          }
        }
        cov_24axaiejip.s[323]++;
        if ((cov_24axaiejip.b[83][0]++, $scope.dashboard.item.SPATIAL_) && (cov_24axaiejip.b[83][1]++, $scope.dashboard.item.SPATIAL________)) {
          cov_24axaiejip.b[82][0]++;
          cov_24axaiejip.s[324]++;

          $scope.mapDisplay.secondSpatial.selectYear();
        } else {
          cov_24axaiejip.b[82][1]++;
        }
      });
    },
    initialize: function initialize() {
      cov_24axaiejip.s[325]++;

      this.period_type = 1;
      cov_24axaiejip.s[326]++;
      if (this.mymap) {
        cov_24axaiejip.b[84][0]++;
        cov_24axaiejip.s[327]++;

        this.mymap.remove();
      } else {
        cov_24axaiejip.b[84][1]++;
      }
      cov_24axaiejip.s[328]++;
      this.mymap = L.map('mapid').setView([16.82, 11.3], 5);

      cov_24axaiejip.s[329]++;
      if (this.layerGroup) {
        cov_24axaiejip.b[85][0]++;
        cov_24axaiejip.s[330]++;

        this.layerGroup.clearLayers();
        cov_24axaiejip.s[331]++;
        this.layerGroup = null;
      } else {
        cov_24axaiejip.b[85][1]++;
      }

      cov_24axaiejip.s[332]++;
      this.getGlobal();
      cov_24axaiejip.s[333]++;
      this.getLayers($scope.dashboard.yearSuivi ? (cov_24axaiejip.b[86][0]++, $scope.dashboard.yearSuivi.id) : (cov_24axaiejip.b[86][1]++, 0), $scope.dashboard.periodSuivi ? (cov_24axaiejip.b[87][0]++, $scope.dashboard.periodSuivi.index) : (cov_24axaiejip.b[87][1]++, 0));
    },
    openMap: function openMap(item) {
      cov_24axaiejip.s[334]++;

      $scope.dashboard.item = item;
      cov_24axaiejip.s[335]++;
      $scope.selectedItemUnit = null;
      cov_24axaiejip.s[336]++;
      for (var _iterator25 = $scope.listData_unites_bksb, _isArray25 = Array.isArray(_iterator25), _i25 = 0, _iterator25 = _isArray25 ? _iterator25 : _iterator25[Symbol.iterator]();;) {
        var _ref25;

        if (_isArray25) {
          if (_i25 >= _iterator25.length) break;
          _ref25 = _iterator25[_i25++];
        } else {
          _i25 = _iterator25.next();
          if (_i25.done) break;
          _ref25 = _i25.value;
        }

        var el = _ref25;
        cov_24axaiejip.s[337]++;

        if (el.id == item.ID_UNITE) {
          cov_24axaiejip.b[88][0]++;
          cov_24axaiejip.s[338]++;

          $scope.selectedItemUnit = el;
          cov_24axaiejip.s[339]++;
          break;
        } else {
          cov_24axaiejip.b[88][1]++;
        }
      }
      cov_24axaiejip.s[340]++;
      $scope.dashboard.listYear = [].concat($deltadate.getYearBetween(item.DEB_EVAL_INDIC, item.FIN_EVAL_INDIC));
      cov_24axaiejip.s[341]++;
      $scope.viewIndex = 10;
      cov_24axaiejip.s[342]++;
      $scope.getGlobalValue(item);
      cov_24axaiejip.s[343]++;
      $scope.dashboard.yearSuivi = $scope.dashboard.listYear[0];
      cov_24axaiejip.s[344]++;
      $scope.dashboard.listSuivi = [];
      cov_24axaiejip.s[345]++;
      if (item.PERIOD_INDIC == 1) {
        cov_24axaiejip.b[89][0]++;
        cov_24axaiejip.s[346]++;

        $scope.dashboard.display_period = false;
      } else {
        cov_24axaiejip.b[89][1]++;
      }
      cov_24axaiejip.s[347]++;
      $scope.mapDisplay.displayCity = false;
      cov_24axaiejip.s[348]++;
      $scope.mapDisplay.displaySatelite = false;
    }
  };
  var listCountry = (cov_24axaiejip.s[349]++, [{ namefr: 'DS', nameen: 'Benin', lat: 10.23, long: 2.45 }, { namefr: 'SD', nameen: 'Burkina Faso', lat: 12.22, long: -1.31 }, { namefr: 'DF', nameen: 'Ethiopia', lat: 9.01, long: 38.44 }, { namefr: '104', nameen: 'Ghana', lat: 7.41, long: -0.15 }, { namefr: '105', nameen: 'Mali', lat: 17.04, long: -1.8 }, { namefr: '106', nameen: 'Mauritanie', lat: 19.83, long: -10.01 }, { namefr: '107', nameen: 'Niger', lat: 18.09, long: 9.43 }, { namefr: '108', nameen: 'Nigeria', lat: 9.81, long: 7.99 }, { namefr: '109', nameen: 'Senegal', lat: 14.59, long: -14.359593 }, { namefr: '110', nameen: 'Sudan', lat: 16.541974, long: 31.736416 }, { namefr: '111', nameen: 'Chad', lat: 14.445452, long: 18.591013 }, { namefr: '112', nameen: 'Togo', lat: 8.750411, long: 0.991081 }]);
  cov_24axaiejip.s[350]++;
  $deltaUnite.addController($scope, function () {
    cov_24axaiejip.f[19]++;
    cov_24axaiejip.s[351]++;

    $scope.openDashboard();
  });
  cov_24axaiejip.s[352]++;
  $deltaGeoLevel.addController($scope, function () {
    cov_24axaiejip.f[20]++;
    cov_24axaiejip.s[353]++;

    $scope.openDashboard();
  });
  cov_24axaiejip.s[354]++;
  $deltaTypeIndicateur.addController($scope, function () {
    cov_24axaiejip.f[21]++;
    cov_24axaiejip.s[355]++;

    $CRUDService.getAll(PATH, { get: 'all', idcl: $stateParams.idcl, id: $stateParams.id, page: $scope.page, nr: true }, function (data) {
      cov_24axaiejip.f[22]++;
      cov_24axaiejip.s[356]++;

      for (var i = 0; i < data.length; i++) {
        cov_24axaiejip.s[357]++;

        data[i].DEB_EVAL_INDIC = Date.newDate(data[i].DEB_EVAL_INDIC);
        cov_24axaiejip.s[358]++;
        data[i].FIN_EVAL_INDIC = Date.newDate(data[i].FIN_EVAL_INDIC);
        cov_24axaiejip.s[359]++;
        data[i].SUIVI_INDIC = data[i].SUIVI_INDIC == 1;
        cov_24axaiejip.s[360]++;
        data[i].Valeur_Cumul = data[i].Valeur_Cumul == 1;
        cov_24axaiejip.s[361]++;
        data[i].Icle_INDIC = data[i].Icle_INDIC == 1;
        cov_24axaiejip.s[362]++;
        data[i].SPATIAL_ = data[i].SPATIAL_ == 1;
        cov_24axaiejip.s[363]++;
        data[i].SPATIAL________ = (cov_24axaiejip.b[90][0]++, data[i].SPATIAL________ == 1) && (cov_24axaiejip.b[90][1]++, data[i].SPATIAL_);
        cov_24axaiejip.s[364]++;
        data[i].SOCIO_ECO = data[i].SOCIO_ECO == 1;
        cov_24axaiejip.s[365]++;
        if (!eval(data[i].IDACTEURS)) {
          cov_24axaiejip.b[91][0]++;
          cov_24axaiejip.s[366]++;

          data[i].IDACTEURS = -100;
        } else {
          cov_24axaiejip.b[91][1]++;
        }
      }
      cov_24axaiejip.s[367]++;
      $scope.openDashboard(data[0]);
    });
  });
});